/** Turkish UI */
import type { Strings } from '@/locales/en';

export const tr: { [K in keyof Strings]: string } = {
  appName: 'Mentora',
  tagline: 'Öğrenciler ve mentorları bir araya getiriyoruz',
  login: 'Giriş Yap',
  register: 'Kayıt Ol',
  forgotPassword: 'Şifremi Unuttum',
  emailOrPhone: 'E-posta veya telefon',
  password: 'Şifre',
  submit: 'Gönder',
  backToLogin: 'Girişe dön',
  backToLanding: 'Ana sayfaya dön',
  logout: 'Çıkış Yap',
  language: 'Dil',
  languageEn: 'İngilizce',
  languageTr: 'Türkçe',
  menuTitle: 'Menü',
  mainMenuAria: 'Ana menü',
  navLockedAria: 'Doğrulama tamamlanana kadar kilitli',
  mobileTabMenuAria: 'Mobil sekme menüsü',
  userDisplayFallback: 'Kullanıcı',
  navPanel: 'Kontrol Paneli',
  navFindMentor: 'Mentor Ara',
  navFavorites: 'Favoriler',
  navMyClasses: 'Dersler',
  navMessages: 'Mesajlar',
  navPurse: 'Cüzdan',
  navProfile: 'Profil',
  navNotifications: 'Bildirimler',
  navDashboard: 'Kontrol Paneli',
  navMyListings: 'İlanlarım',
  navAvailability: 'Müsaitlik',
  navEarnings: 'Kazançlar',
  navMyStudents: 'Öğrencilerim',
  navMaterials: 'Materyaller',
  dashboard: 'Kontrol Paneli',
  dashboardLoadError: 'Kontrol paneli yüklenemedi',
  lessons: 'Dersler',
  noUpcomingLessons: 'Yaklaşan dersiniz yok',
  noUpcomingLessonsDescription: 'Yeni bir ders planlandığında burada görünecek.',
  noUpcomingLessonsHint:
    'Yeni bir mentor bulabilir veya geçmiş ders raporlarını inceleyebilirsiniz.',
  noPastLessons: 'Geçmiş ders yok',
  noPastLessonsDescription:
    'Tamamlanan dersleriniz, konu veya öğrenci grupları halinde burada listelenecek.',
  lessonsPageDescription: 'Çocuğunuzun yaklaşan ve geçmiş derslerini buradan takip edin.',
  lessonsPageDescriptionStudent: 'Yaklaşan ve geçmiş derslerinizi buradan takip edin.',
  lessonsTabUpcoming: 'Yaklaşan',
  lessonsTabPast: 'Geçmiş',
  lessonsStudentLabel: 'Öğrenci',
  lessonsAllStudents: 'Tüm öğrenciler',
  lessonsSearchStudents: 'Öğrenci ara…',
  lessonsFilterSubject: 'Konu / Hizmet',
  lessonsFilterMentor: 'Mentor',
  lessonsFilterDateRange: 'Tarih aralığı',
  lessonsViewDetails: 'Detayları Gör',
  lessonsViewPastLessons: 'Geçmiş Dersleri Gör',
  lessonsLastLesson: 'Son ders: {{date}}',
  lessonsSessionCount: '{{count}} ders oturumu',
  lessonsSessionCountOne: '1 ders oturumu',
  lessonsStatUpcoming: 'Yaklaşan Dersler',
  lessonsStatCompleted: 'Tamamlanan Dersler',
  lessonsStatReportsReady: 'Hazır Raporlar',
  lessonsStatTotalHours: 'Toplam Ders Saati',
  lessonsStatNoDataYet: 'Henüz veri yok',
  lessonsHoursUnit: 'Saat',
  lessonsNextUp: 'Sıradaki ders',
  lessonsSelectedDay: 'Seçilen gün',
  lessonsSessionSingular: 'oturum',
  lessonsSessionPlural: 'oturum',
  lessonsNoSessionsThisDay: 'Bu tarihte ders yok',
  lessonsNoSessionsThisDayHint:
    'Takvimden başka bir gün seçin — mor noktalar ders olan günleri gösterir.',
  lessonsLoadError: 'Dersler yüklenemedi',
  lessonsRoleRestricted: 'Dersler yalnızca öğrenci, veli veya mentor hesabıyla görüntülenebilir.',
  reportStatusReady: 'Rapor hazır',
  reportStatusProcessing: 'Rapor hazırlanıyor',
  reportStatusNone: 'Rapor yok',
  reportStatusNotCompleted: 'Ders tamamlanmadı',
  reportStatusUnknown: 'Rapor durumu bilinmiyor',
  reportStatusWaitingLesson: 'Ders tamamlandıktan sonra hazırlanacak',
  reportStatusSummaryReady: 'Özet hazır',
  reportStatusQuizNotAssigned: 'Quiz atanmadı',
  reportStatusQuizCompleted: 'Quiz tamamlandı',
  reportStatusQuizAssigned: 'Quiz atandı',
  reportStatusMentorNoteMissing: 'Mentor notu henüz eklenmedi',
  reportStatusMentorNoteAdded: 'Mentor notu eklendi',
  reportStatusSummaryPending: 'Özet bekleniyor',
  reportStatusSummaryProcessing: 'Özet hazırlanıyor',
  lessonGroupPlannedEmptyTitle: 'Bu ders henüz tamamlanmadı.',
  lessonGroupPlannedEmptyDescription:
    'Ders tamamlandıktan sonra transkript, yapay zeka özeti, quiz ve mentor notları burada görünecek.',
  lessonGroupCompletedNoReportTitle: 'Ders tamamlandı. Rapor hazırlanıyor.',
  lessonGroupCompletedNoReportDescription:
    'Transkript hazırlandıktan sonra yapay zeka özeti oluşturulacak.',
  lessonGroupReportReadyTitle: 'Ders raporu hazır.',
  lessonGroupCancelledTitle: 'Bu ders iptal edildi',
  lessonGroupUpcomingSection: 'Yaklaşan / Planlanan',
  lessonGroupCompletedSection: 'Tamamlanan',
  lessonGroupCancelledSection: 'İptal edilen',
  lessonGroupSidebarStudent: 'Öğrenci',
  lessonGroupSidebarMentor: 'Mentor',
  lessonGroupSidebarSubject: 'Konu / Hizmet',
  lessonGroupTotalSessions: 'Toplam oturum',
  lessonGroupTotalCompletedTime: 'Toplam tamamlanan süre',
  lessonGroupQuickActions: 'Hızlı işlemler',
  requestNewLesson: 'Yeni ders talep et',
  viewMaterials: 'Materyalleri görüntüle',
  viewReportStatus: 'Rapor durumunu görüntüle',
  viewReport: 'Raporu Görüntüle',
  viewSessions: 'Oturumları Gör',
  viewQuizResults: 'Quiz sonuçlarını görüntüle',
  nextSteps: 'Sonraki adımlar',
  lessonInfoTitle: 'Ders Bilgileri',
  lessonInfoSubject: 'Konu/Hizmet',
  lessonInfoStudent: 'Öğrenci',
  lessonInfoMentor: 'Mentor',
  lessonInfoDate: 'Tarih',
  lessonInfoDuration: 'Süre',
  lessonInfoStatus: 'Durum',
  reportStatusCardLesson: 'Ders Durumu',
  reportStatusCardAiSummary: 'Yapay Zeka Özeti',
  reportStatusCardQuiz: 'Quiz',
  reportStatusCardMentorNote: 'Mentor Notu',
  reportPlannedBannerTitle: 'Bu ders henüz tamamlanmadı.',
  reportPlannedBannerDescription:
    'Ders tamamlandıktan sonra transkript, yapay zeka özeti, quiz ve mentor notları burada görünecek.',
  reportProcessingBannerTitle: 'Ders tamamlandı. Rapor hazırlanıyor.',
  reportProcessingBannerDescription:
    'Yapay zeka özeti transkript hazırlandıktan sonra oluşturulacak.',
  reportStatusCardTranscript: 'Transkript',
  reportStatusCardReview: 'Değerlendirme',
  aiSummaryNotReadyPlannedTitle: 'Ders özeti henüz hazır değil',
  aiSummaryNotReadyPlannedDescription:
    'Ders tamamlandıktan ve transkript hazırlandıktan sonra yapay zeka özeti burada görünecek.',
  aiSummaryProcessingTitle: 'Ders tamamlandı, özet hazırlanıyor',
  aiSummaryProcessingDescription: 'Transkript hazırlandıktan sonra yapay zeka özeti oluşturulacak.',
  aiSummaryFailedTitle: 'Ders özeti oluşturulamadı',
  aiSummaryFailedDescription: 'Transkript alınamadığı için yapay zeka özeti hazırlanamadı.',
  aiSummaryTopicsCovered: 'Ders sırasında işlenen konular',
  aiSummaryStudentStrengths: 'Öğrencinin güçlü olduğu alanlar',
  aiSummaryPracticeAreas: 'Pratik yapması gereken alanlar',
  aiSummaryNextLessonSuggestions: 'Sonraki ders için öneriler',
  quizNotAssignedTitle: 'Henüz quiz atanmadı',
  quizNotAssignedDescription: 'Mentor quiz oluşturduğunda burada görünecek.',
  quizAssignedTitle: 'Quiz atandı',
  quizAssignedWaitingDescription: 'Öğrenci quiz’i tamamladığında sonuçlar burada görünecek.',
  quizResultScore: 'Skor: {{score}}/{{total}}',
  quizResultCompletionStatus: 'Tamamlanma durumu: Tamamlandı',
  quizResultCompletedAt: 'Tamamlanma tarihi: {{date}}',
  mentorNoteEmpty: 'Mentor henüz bu ders için not eklemedi.',
  mentorNoteNoneYet: 'Mentor notu henüz eklenmedi.',
  rateLessonTitle: 'Dersi değerlendir',
  rateLessonDescription: 'Bu ders için deneyiminizi paylaşın.',
  submitRating: 'Değerlendirme gönder',
  yourRatingTitle: 'Değerlendirmeniz',
  ratingAfterCompleted: 'Değerlendirme ders tamamlandıktan sonra yapılabilir.',
  ratingUnavailableApi: 'Ders değerlendirmesi yakında burada olacak.',
  participationLevel: 'Katılım',
  understandingScore: 'Anlama',
  engagementScore: 'İlgi',
  knowledgeGapLabel: 'Bilgi boşluğu',
  studentsGradeShort: 'Sınıf {{grade}}',
  lessonsJoinNotAllowed: 'Bu oturuma henüz katılamazsınız.',
  lessonsJoinFailed: 'Oturuma katılınamadı. Lütfen tekrar deneyin.',
  meetJoinActive: 'Derse Katıl',
  meetJoinPending: 'Link hazırlanıyor',
  meetJoinPendingHint: 'Ders bağlantısı kısa süre içinde hazır olacak.',
  meetJoinFailed: 'Link oluşturulamadı',
  meetJoinFailedHint: 'Lütfen destek ile iletişime geçin.',
  meetJoinNotYet: 'Ders saatinde aktif olacak',
  meetJoinNoLink: 'Ders bağlantısı yok',
  meetProviderGoogle: 'Google Meet',
  meetRetryLink: 'Bağlantıyı yeniden oluştur',
  meetRetrySuccess: 'Ders bağlantısı hazır',
  meetRetryPending: 'Ders bağlantısı hâlâ hazırlanıyor',
  meetRetryFailed: 'Ders bağlantısı oluşturulamadı',
  messages: 'Mesajlar',
  wallet: 'Cüzdan',
  profile: 'Profil',
  notifications: 'Bildirimler',
  notificationsLoadError: 'Bildirimler yüklenemedi',
  notificationsEmpty: 'Bildirim yok',
  markAllNotificationsRead: 'Tümünü okundu işaretle',
  notificationDefaultTitle: 'Bildirim',
  notificationNewMessageTitle: 'Yeni mesaj',
  notificationNewMessageBody: '{{name}} size bir mesaj gönderdi.',
  availability: 'Müsaitlik',
  earnings: 'Kazançlar',
  welcome: 'Hoş geldiniz',
  welcomeBackTitle: 'Tekrar hoş geldiniz',
  welcomeBackGreeting: 'Tekrar hoş geldiniz, {{name}}!',
  welcomeBackSubtitle: 'Öğrenmeye devam etmek için giriş yapın',
  creditUnit: 'kredi',
  linkedStudentNotFound: 'Bağlı öğrenci bulunamadı.',
  quickActionJoinLesson: 'Derse katıl',
  quickActionMyLessons: 'Derslerim',
  quickActionMessages: 'Mesajlar',
  quickActionFindMentor: 'Mentor Ara',
  quickActionWallet: 'Cüzdan',
  quickActionChildProgress: 'Çocuk ilerlemesi',
  quickActionAvailability: 'Müsaitlik',
  quickActionEarnings: 'Kazançlar',
  quickActionListings: 'İlanlarım',
  registerCardTitle: 'Hesap oluştur',
  registerCardSubtitle: 'Rolünüzü seçin ve bilgilerinizi girin',
  forgotCardSubtitle: 'E-posta veya telefonunuza sıfırlama bağlantısı gönderilir.',
  upcomingLesson: 'Yaklaşan ders',
  dashboardQuickActions: 'Hızlı işlemler',
  dashboardJoinLesson: 'Derse katıl',
  dashboardViewDetails: 'Detayları gör',
  dashboardLessonTopic: 'Konu',
  dashboardGrade: 'Sınıf',
  dashboardAddCredits: 'Kredi ekle',
  dashboardOpenSlots: 'Açık',
  dashboardBookedSlots: 'Dolu',
  dashboardEarningsToday: 'Bugün',
  dashboardEarningsWeek: 'Hafta',
  dashboardEarningsMonth: 'Ay',
  dashboardNoScheduleToday: 'Bugün planlanmış ders yok',
  dashboardNoScheduleTodayHint: 'Bugün dersiniz olduğunda burada görünecek.',
  todaySchedule: 'Bugünkü program',
  linkedStudents: 'Bağlı öğrenci',
  walletBalance: 'Cüzdan bakiyesi',
  lessonsOverview: 'Ders özeti',
  aiReport: 'Yapay zeka raporu',
  availabilityStatus: 'Müsaitlik durumu',
  earningsPlaceholder: 'Kazanç özeti',
  earningsPageDescription: 'Mentor cüzdan bakiyeleriniz ve çekilebilir tutar.',
  earningsLoadError: 'Kazanç verisi alınamadı',
  earningsAvailablePayout: 'Çekilebilir tutar',
  earningsPending: 'Bekleyen',
  earningsTotalEarned: 'Toplam kazanç',
  earningsTotalPaidOut: 'Toplam ödeme',
  earningsTotalBalance: 'Toplam bakiye',
  earningsTotalBonuses: 'Bonuslar',
  earningsTotalReversed: 'İadeler',
  mentorWalletPreviewHint: 'Kazanç ve ödemeleri görüntüle',
  mentorWalletPreviewError: 'Cüzdan yüklenemedi',
  mentorWalletPageDescription: 'Kazanç ve ödeme detaylarınız.',
  mentorWalletPendingInline: 'Bekleyen',
  mentorWalletPayoutActionsTitle: 'Ödeme işlemleri',
  mentorWalletPayoutActionsHint: 'Ödeme talep edin veya banka bilgilerinizi yönetin.',
  mentorWalletRequestPayout: 'Ödeme talep et',
  mentorWalletManagePayoutMethods: 'Ödeme yöntemlerini yönet',
  mentorWalletPayoutRequestsTitle: 'Ödeme talepleri',
  mentorWalletTransactionsTitle: 'İşlemler',
  mentorWalletPayoutRequestsLoadError: 'Ödeme talepleri yüklenemedi',
  mentorWalletTransactionsLoadError: 'İşlemler yüklenemedi',
  mentorWalletNoPayoutRequestsTitle: 'Henüz ödeme talebi yok',
  mentorWalletNoPayoutRequestsBody: 'Ödeme talepleriniz burada görünecek.',
  mentorWalletNoTransactionsTitle: 'Henüz cüzdan hareketi yok',
  mentorWalletNoTransactionsBody: 'Kazanç ve ödeme hareketleriniz burada görünecek.',
  mentorWalletPayoutMethodsTitle: 'Ödeme yöntemleri',
  mentorWalletPayoutMethodsHint: 'Banka havalesi bilgilerinizi ekleyin ve yönetin.',
  mentorWalletPayoutMethodsPageDescription: 'Ödemeler için kullanılan banka havalesi bilgileri.',
  mentorWalletPayoutMethodsLoadError: 'Ödeme yöntemleri yüklenemedi',
  mentorWalletNoPayoutMethodsTitle: 'Henüz ödeme yöntemi eklenmedi',
  mentorWalletNoPayoutMethodsBody: 'Ödeme talep edebilmek için bir banka havalesi yöntemi ekleyin.',
  mentorWalletAddPayoutMethod: 'Ödeme yöntemi ekle',
  mentorWalletEditPayoutMethodTitle: 'Ödeme yöntemini düzenle',
  mentorWalletAddPayoutMethodTitle: 'Ödeme yöntemi ekle',
  mentorWalletPayoutMethodFormDescription: 'Banka havalesi bilgilerinizi girin.',
  mentorWalletBankTransfer: 'Banka havalesi',
  mentorWalletDefaultBadge: 'Varsayılan',
  mentorWalletSetDefault: 'Varsayılan yap',
  mentorWalletDeactivate: 'Devre dışı bırak',
  mentorWalletNoPayoutMethodBlocker: 'Ödeme talep etmek için aktif bir ödeme yöntemi ekleyin.',
  mentorWalletPayoutMethodLabel: 'Ödeme yöntemi',
  mentorWalletAmountLabel: 'Tutar',
  mentorWalletInvalidPayoutAmount:
    '0’dan büyük ve kullanılabilir bakiyeyi aşmayan bir tutar girin.',
  mentorWalletNoActiveMethod: 'Aktif ödeme yöntemi bulunamadı.',
  mentorWalletSubmitPayoutRequest: 'Ödeme talebini gönder',
  mentorWalletRequestedAtLabel: 'Talep tarihi',
  mentorWalletPaidAtLabel: 'Ödeme tarihi',
  mentorWalletFailureReasonLabel: 'Hata nedeni',
  mentorWalletAccountHolderName: 'Hesap sahibi adı',
  mentorWalletIban: 'IBAN',
  mentorWalletBankName: 'Banka adı',
  mentorWalletBranchNameOptional: 'Şube adı (opsiyonel)',
  mentorWalletAccountNumberOptional: 'Hesap numarası (opsiyonel)',
  mentorWalletFieldRequired: 'Bu alan zorunludur.',
  mentorWalletLoadErrorTitle: 'Cüzdan yüklenemedi',
  mentorWalletLoadErrorBody: 'Lütfen tekrar deneyin.',
  loadMore: 'Daha fazla yükle',
  edit: 'Düzenle',
  save: 'Kaydet',
  loading: 'Yükleniyor…',
  errorTitle: 'Bir şeyler ters gitti',
  retry: 'Yeniden dene',
  empty: 'Henüz kayıt yok',
  suspendedTitle: 'Hesap kullanılamıyor',
  suspendedBody: 'Hesabınız şu anda askıya alındı. Destek ile iletişime geçin.',
  searchMentors: 'Mentor Ara',
  findMentor: 'Mentor Ara',
  searchPlaceholder: 'Mentor, ders veya sınıf seviyesi ara…',
  noMentorsFound: 'Mentor bulunamadı.',
  noMentorsHint: 'Aramanızı veya filtrelerinizi değiştirmeyi deneyin.',
  mentorsLoadError: 'Mentorlar yüklenemedi.',
  mentorProfileLoadError: 'Mentor profili yüklenemedi.',
  listingLoadError: 'İlan detayı yüklenemedi.',
  favouriteUpdateError: 'Favori güncellenemedi.',
  verifiedMentor: 'Onaylı mentor',
  viewServices: 'Hizmetleri gör',
  viewMentor: 'Mentoru gör',
  services: 'Hizmetler',
  aboutMentor: 'Hakkında',
  noActiveServices: 'Bu mentorun şu anda aktif hizmeti yok.',
  priceDuringBooking: 'Fiyat rezervasyon sırasında gösterilir',
  bookLesson: 'Ders rezerve et',
  continueToBooking: 'Rezervasyona devam',
  addToFavourites: 'Favorilere ekle',
  askParentToBook: 'Veliden rezerve etmesini iste',
  studentBookingNote:
    'Yalnızca veliler ders rezerve edebilir. Velinizin incelemesi için bu mentoru favorilere ekleyebilirsiniz.',
  studentContactNote:
    'Yalnızca veliler mentorlarla doğrudan iletişime geçebilir. Lütfen velinizden iletişime geçmesini isteyin.',
  contactMentorWelcomeMessage:
    'Merhaba, verdiğiniz hizmetler hakkında sizinle iletişime geçmek istiyorum.',
  studentBookingBlocked:
    'Yalnızca veliler ders rezerve edebilir. Velinizin görmesi için bu mentoru favorilere ekleyin.',
  favourites: 'Favoriler',
  favouritesEmpty: 'Henüz favori mentorunuz yok.',
  favouritesTabMentors: 'Mentorlar',
  favouritesTabListings: 'İlanlar',
  noSavedListings: 'Henüz kayıtlı ilan yok.',
  savedListingsHint: 'Rezervasyon öncesi karşılaştırmak için ders ilanlarını kaydedin.',
  byMentor: '{{name}} tarafından',
  savedLessonListing: 'Kayıtlı ders ilanı',
  viewListing: 'İlanı görüntüle',
  remove: 'Kaldır',
  removeFromFavourites: 'Favorilerden kaldır',
  studentFavouriteMentors: 'Öğrencinin favori mentorları',
  listingDetail: 'Hizmet detayı',
  howManyLessons: 'Kaç ders rezerve etmek istiyorsunuz?',
  lessonHourNote: 'Her ders 1 saattir.',
  customLessonCount: 'Özel',
  availableSlots: 'Müsait saatler',
  slotsLoading: 'Müsait saatler yükleniyor…',
  slotsEmpty: 'Bu dönem için müsait saat yok.',
  slotsLoadError: 'Müsait saatler yüklenemedi.',
  bookingSummary: 'Rezervasyon özeti',
  nextStep: 'Sonraki adım',
  continueToPayment: 'Ödemeye devam',
  paymentPlaceholder: 'Ödeme akışı bir sonraki adımda bağlanacak.',
  checkoutTitle: 'Rezervasyonu onayla',
  checkoutSubtitle: 'Dahili kredi ile ödeme simülasyonu (gerçek ödeme ağ geçidi yok).',
  checkoutCreditsTitle: 'Kredi işlemi',
  checkoutInitialBalance: 'Mevcut bakiye',
  checkoutPackage: 'Paket kredisi',
  checkoutConsume: 'Kullanılacak kredi',
  checkoutFinalBalance: 'İşlem sonrası bakiye',
  checkoutDummyNotice:
    'Bu adım dahili kredi mantığını kullanır. Gerçek kart ödemesi ileride eklenecektir.',
  checkoutMissingBooking: 'Rezervasyon bulunamadı',
  checkoutFailed: 'Ödeme tamamlanamadı',
  confirmBooking: 'Rezervasyonu onayla',
  bookingConfirmed: 'Rezervasyon onaylandı',
  bookingCreateFailed: 'Rezervasyon oluşturulamadı',
  goToDashboard: 'Panele git',
  viewLessons: 'Derslerime git',
  selectedTimes: 'Seçilen saatler',
  selectStudent: 'Öğrenci seçin',
  selectStudentHint: 'Bu rezervasyon hangi öğrenci için?',
  creditsUnit: 'kredi',
  processing: 'İşleniyor…',
  bookingStep: 'Adım',
  selectSlotsHint: 'Lütfen seçilen ders sayısı kadar saat seçin.',
  clearFilters: 'Filtreleri temizle',
  activeListings: 'aktif',
  views: 'görüntülenme',
  bookings: 'rezervasyon',
  filterMathematics: 'Matematik',
  filterPhysics: 'Fizik',
  filterHighSchool: 'Lise',
  filterOneToOne: '1:1',
  filterGroup: 'Grup',
  filtersAriaLabel: 'Arama filtreleri',
  clearSearch: 'Aramayı temizle',
  mentorsFound: '{{count}} mentor bulundu',
  gradeLabel: 'Sınıf',
  servicesLabel: 'Hizmetler',
  expertIn: 'Uzman: {{subjects}}',
  ratingNotAvailable: 'Henüz değerlendirme yok',
  viewListingDetails: 'Detayları gör',
  invalidBookingLink: 'Geçersiz rezervasyon bağlantısı.',
  bookingSummaryMentor: 'Mentor',
  bookingSummaryService: 'Hizmet',
  bookingSummaryLessonCount: 'Ders sayısı',
  bookingSummaryEstimated: 'Tahmini tutar',
  slotNoLongerAvailable:
    'Seçilen saatlerden biri artık müsait değil. Lütfen müsaitlik ekranına dönüp yeniden seçin.',
  parentOnlyBooking: 'Yalnızca veliler ders rezerve edebilir.',
  accessRestricted: 'Erişim kısıtlı',
  studentBookingRestrictedBody:
    'Öğrenciler doğrudan ders rezervasyonu yapamaz. Bu dersi rezerve etmesi için lütfen velinizden yardım isteyin.',
  ok: 'Tamam',
  studentFavouritesTitle: '{{name}} favori mentorları',
  studentFavouritesEmpty: 'Henüz favori mentor yok.',
  studentFavouritesLoadError: 'Öğrenci favorileri yüklenemedi.',
  postListing: 'İlanlar',
  myPostings: 'İlanlarım',
  createNewListing: 'Yeni ilan',
  createListingTitle: 'Yeni ilan oluştur',
  createListingDescription: 'Öğrencilerin ve velilerin görebileceği bir ders ilanı ekleyin.',
  createListingSubmit: 'İlanı oluştur',
  editListingTitle: 'İlanı düzenle',
  editListingDescription: 'Ders ilanı bilgilerinizi güncelleyin.',
  saveListingChanges: 'Değişiklikleri kaydet',
  listingsEmpty: 'Henüz ders ilanınız yok.',
  listingsLoadError: 'İlanlar yüklenemedi.',
  listingCreated: 'İlan başarıyla oluşturuldu.',
  listingUpdated: 'İlan güncellendi.',
  listingCreateError: 'İlan oluşturulamadı.',
  listingUpdateError: 'İlan güncellenemedi.',
  listingStatusUpdateError: 'İlan durumu güncellenemedi.',
  listingNotFound: 'İlan bulunamadı.',
  refreshList: 'Yenile',
  listingViews: 'Görüntülenme',
  listingBookings: 'Rezervasyon',
  editListing: 'Düzenle',
  manageListings: 'Ders ilanlarınızı yönetin',
  goToMyPostings: 'İlanlara git',
  noAccountPrompt: 'Hesabınız yok mu?',
  signUpLink: 'Kayıt Ol',
  notProvided: 'Belirtilmedi',
  noPhone: 'Telefon eklenmemiş',
  noLinkedChild: 'Henüz bağlı öğrenci yok',
  editProfile: 'Profili düzenle',
  saveProfile: 'Kaydet',
  cancel: 'İptal',
  back: 'Geri',
  firstName: 'Ad',
  lastName: 'Soyad',
  phone: 'Telefon',
  email: 'E-posta',
  role: 'Rol',
  bio: 'Kısa biyografi',
  university: 'Üniversite',
  verificationStatus: 'Doğrulama durumu',
  childName: 'Öğrenci adı',
  childEmail: 'Öğrenci e-postası',
  dateOfBirth: 'Doğum tarihi',
  ageYears: 'Yaş',
  parentInfo: 'Veli bilgisi',
  profilePhotoPlaceholder: 'Profil fotoğrafı',
  profilePhotoHint:
    'Önce dosya yüklenir, ardından görüntülemek için kısa süreli bir bağlantı alınır.',
  profilePhotoEditHint: 'Fotoğrafı buradan veya mobil uygulamadan güncelleyebilirsiniz.',
  changePhoto: 'Fotoğraf seç',
  photoUploadOk: 'Profil fotoğrafı güncellendi',
  photoUploadFailed: 'Fotoğraf yüklenemedi',
  photoTooLarge: 'Dosya en fazla 5 MB olabilir',
  logoutConfirmTitle: 'Çıkış yapılsın mı?',
  logoutConfirmBody: 'Oturumunuz kapatılacak ve giriş sayfasına yönlendirileceksiniz.',
  logoutConfirmAction: 'Çıkış yap',
  unsavedTitle: 'Kaydedilmemiş değişiklikler',
  unsavedBody: 'Sayfadan ayrılmak istediğinize emin misiniz? Yaptığınız değişiklikler kaybolur.',
  stayOnPage: 'Sayfada kal',
  leavePage: 'Ayrıl',
  profileUpdated: 'Profil güncellendi',
  profileLoadError: 'Profil yüklenemedi',
  profileSaveError: 'Kayıt başarısız',
  roleParent: 'Veli',
  roleMentor: 'Mentor',
  roleStudent: 'Öğrenci',
  verificationNotStarted: 'Başlamadı',
  verificationPending: 'Beklemede',
  verificationVerified: 'Onaylı',
  verificationFailed: 'Başarısız',
  loginFailed: 'Giriş başarısız',
  verifyTitle: 'Hesabınızı doğrulayın',
  verifyEmailSubtitle: 'E-postanıza gönderilen 6 haneli kodu girin:',
  verifyPhoneSubtitle: 'Telefonunuza gönderilen 6 haneli kodu girin:',
  verificationCode: 'Doğrulama kodu',
  verifyAndContinue: 'Doğrula ve devam et',
  verifyResendPrompt: 'Kod gelmedi mi?',
  verifyResendNow: 'Tekrar gönder',
  verifyResendIn: '{{seconds}} sn sonra tekrar gönder',
  verifyCodeIncomplete: '6 haneli kodu eksiksiz girin',
  verifyTargetMissing: 'Doğrulama hedefi bulunamadı',
  verifySuccess: 'Doğrulama başarılı',
  verifyFailed: 'Doğrulama başarısız',
  verifyResent: 'Yeni kod gönderildi',
  verifyResendFailed: 'Kod tekrar gönderilemedi',
  verifyFlowUnknown: 'Sonraki doğrulama adımı belirlenemedi',
  verifyContactSupportTitle: 'Destek ile iletişime geçin',
  verifyContactSupportBody:
    'Hesabınızda giriş yapmadan önce destek ekibinin müdahalesi gerekiyor. Lütfen Mentora destek ile iletişime geçin.',
  devOtpHint: 'Geliştirme: sabit OTP {{code}}',
  forgotPasswordFailed: 'Şifre sıfırlama başlatılamadı',
  resetPasswordTitle: 'Yeni şifre belirleyin',
  resetPasswordSubtitle: 'Hesabınız için güçlü bir şifre seçin.',
  newPassword: 'Yeni şifre',
  confirmNewPassword: 'Yeni şifre (tekrar)',
  resetPasswordSubmit: 'Şifreyi güncelle',
  resetPasswordSuccess: 'Şifre güncellendi. Giriş yapabilirsiniz.',
  resetPasswordSuccessTitle: 'Şifre güncellendi',
  resetPasswordFailed: 'Şifre güncellenemedi',
  resetVerifyTitle: 'Kimliğinizi doğrulayın',
  resetVerifySubtitle: 'Şunun için gönderilen doğrulama kodunu girin:',
  resetCodeRequired: 'Devam etmek için aldığınız kodu girin',
  showPassword: 'Şifreyi göster',
  hidePassword: 'Şifreyi gizle',
  education: 'Eğitim',
  educationPrimary: 'İlkokul',
  educationMiddle: 'Ortaokul',
  educationHigh: 'Lise',
  subjectsAndGrades: 'Dersler ve Desteklenen Sınıflar',
  examPreparation: 'Sınav Hazırlığı',
  noUniversitySelected: 'Henüz üniversite seçilmedi.',
  noSubjectsAdded: 'Henüz ders eklenmedi.',
  noExamSubjectsAdded: 'Henüz sınav hazırlık dersi eklenmedi.',
  attendanceStatus: 'Devam durumu',
  currentlyAttending: 'Halen okuyor',
  graduated: 'Mezun',
  universitySearchPlaceholder: 'Üniversite ara…',
  universitySearchEmpty: 'Üniversite bulunamadı.',
  universitySearchError: 'Üniversiteler yüklenemedi.',
  clearSelection: 'Temizle',
  addProficiency: 'Ekle',
  removeSubject: 'Dersi kaldır',
  removeGrade: 'Sınıfı kaldır',
  selectEducationLevel: 'Eğitim seviyesi',
  selectGrade: 'Sınıf',
  selectSubject: 'Ders',
  selectExamTrack: 'Sınav türü',
  selectExamSubject: 'Sınav dersi',
  addExamSubject: 'Sınav dersi ekle',
  gradesLabel: 'Sınıflar',
  gradesRange: 'Sınıf {{range}}',
  moreProficiencies: '+{{count}} tane daha',
  filterUniversity: 'Üniversite',
  filterEducationLevel: 'Eğitim seviyesi',
  filterExactGrade: 'Sınıf',
  filterSubject: 'Ders',
  filterExamPrep: 'Sınav hazırlığı',
  filterMinRating: 'Min. puan',
  filterRatingAny: 'Tümü',
  filterQuickTags: 'Hızlı etiketler',
  searchFilters: 'Filtreler',
  searchFiltersHint: 'Üniversite, ders ve daha fazlasına göre sonuçları daraltın',
  selectEducationLevelFirst: 'Önce eğitim seviyesi seçin',
  activeFilters: 'Aktif filtreler',
  clearAllFilters: 'Tümünü temizle',
  subjectsLoadError: 'Dersler yüklenemedi.',
  examSubjectsLoadError: 'Sınav dersleri yüklenemedi.',
  structuredListingSubject: '{{subject}} — Sınıf {{grades}}',
  profileErrorInvalidUniversity: 'Seçilen üniversite geçerli değil. Başka bir üniversite seçin.',
  profileErrorInvalidSubjectGrade: 'Bir veya daha fazla ders ve sınıf kombinasyonu geçerli değil.',
  profileErrorInvalidExamSubject: 'Bir veya daha fazla sınav hazırlık dersi geçerli değil.',
  noDate: 'Tarih yok',
  lessonDefaultTitle: 'Ders',
  withParticipant: '{{name}} ile',
  minutesUnit: 'dk',
  messageButton: 'Mesaj gönder',
  detailButton: 'Detay',
  lessonReportButton: 'Ders raporu',
  backToLessons: 'Derslere dön',
  invalidSession: 'Geçersiz oturum',
  invalidLesson: 'Geçersiz ders',
  lessonDetailTitle: 'Ders detayı',
  lessonDetailLoadError: 'Ders detayı yüklenemedi',
  lessonReportTitle: 'Ders raporu',
  lessonReportLoadError: 'Ders raporu yüklenemedi',
  lessonSessionsLoadError: 'Oturumlar yüklenemedi',
  noPastSessions: 'Geçmiş oturum yok',
  noPastSessionsDescription: 'Bu grup için henüz tamamlanmış ders bulunmuyor.',
  topicNotSpecified: 'Konu belirtilmedi',
  mentorNote: 'Mentor notu',
  mentorNotePlaceholder: 'Oturum notunuzu yazın…',
  saveNote: 'Not kaydet',
  updateNote: 'Notu güncelle',
  noteSaved: 'Not kaydedildi',
  noteSaveFailed: 'Not kaydedilemedi',
  recordingNotice:
    'Bu ders kaydedilebilir ve ders sonrası özet ile quiz oluşturmak için yazıya dökülebilir. Derse katıldığınızda kayıt onayı istenecektir.',
  endLesson: 'Dersi bitir',
  endLessonConfirm: 'Bu dersi bitirmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
  endLessonSuccess: 'Ders tamamlandı olarak işaretlendi.',
  endLessonSummarySuccess: 'Ders tamamlandı ve yapay zeka özeti oluşturuldu.',
  endLessonFailed: 'Ders bitirilemedi.',
  consentSaveFailed: 'Kayıt onayı kaydedilemedi.',
  recordingConsentTitle: 'Ders kaydı',
  recordingConsentBody:
    'Bu ders, otomatik özet ve quiz oluşturmak için yapay zeka not alanı tarafından kaydedilecek ve yazıya dökülecektir. Kaydedilmeyi kabul ediyor musunuz?',
  decline: 'Reddet',
  accept: 'Kabul ediyorum',
  sessionStatusScheduled: 'Planlandı',
  sessionStatusCompleted: 'Tamamlandı',
  sessionStatusCancelled: 'İptal edildi',
  sessionStatusRescheduled: 'Ertelendi',
  sessionStatusInProgress: 'Devam ediyor',
  sessionStatusPlanned: 'Planlandı',
  listingStatusActive: 'Aktif',
  listingStatusInactive: 'Pasif',
  listingFormatGroup: 'Grup',
  listingFormatOneToOne: '1:1',
  listingLessonFormat: 'Ders formatı',
  listingGradePrimary: 'İlkokul',
  listingGradeMiddleSchool: 'Ortaokul',
  listingGradeHighSchool: 'Lise',
  listingSubjectMathematics: 'Matematik',
  listingSubjectPhysics: 'Fizik',
  listingSubjectChemistry: 'Kimya',
  listingSubjectBiology: 'Biyoloji',
  listingSubjectEnglish: 'İngilizce',
  listingSubjectComputerScience: 'Bilgisayar Bilimi',
  listingSubjectHistory: 'Tarih',
  listingSubjectEconomics: 'Ekonomi',
  transcriptStatusLabel: 'Transkript durumu',
  transcriptReadyAiAvailable: 'Transkript hazır. Yapay zeka özellikleri kullanılabilir.',
  transcriptInProgress: 'Transkript işleniyor.',
  transcriptScheduled: 'Transkript kaydı planlandı.',
  transcriptFailedDetail:
    'Transkript kaydı başarısız oldu. Yapay zeka özeti ve quiz kullanılamayabilir.',
  transcriptFailed: 'Bu ders için transkript kullanılamıyor.',
  transcriptNotScheduled: 'Bu oturum için transkript kaydı planlanmadı.',
  aiContentBeingPrepared: 'Yapay zeka içeriği hazırlanıyor.',
  lessonTranscript: 'Ders Transkripti',
  transcriptLoading: 'Transkript yükleniyor…',
  transcriptNotReady: 'Transkript henüz hazır değil. Lütfen daha sonra tekrar kontrol edin.',
  transcriptTextUnavailable: 'Transkript metni henüz kullanılamıyor.',
  viewFullTranscript: 'Tam transkripti görüntüle',
  fullSessionTranscript: 'Tam oturum transkripti',
  aiLessonSummary: 'Yapay Zeka Ders Özeti',
  loadingAiSummary: 'Yapay zeka özeti yükleniyor…',
  aiSummaryLoadError: 'Yapay zeka özeti yüklenemedi.',
  aiSummaryUnavailable: 'Yapay zeka özeti henüz kullanılamıyor.',
  aiSummaryTranscriptFailed: 'Transkript kullanılamadığı için yapay zeka özeti oluşturulamadı.',
  aiSummaryWaitingTranscript: 'Ders transkripti hazır olduktan sonra yapay zeka özeti görünecek.',
  aiSummaryGenerating: 'Yapay zeka özetinizi oluşturuyor. Kısa süre sonra tekrar kontrol edin.',
  aiSummaryEmpty: 'Yapay zeka ders özeti burada görünecek.',
  generateAiSummary: 'Yapay Zeka Özeti Oluştur',
  generatingSummary: 'Özet oluşturuluyor…',
  generateAiSummaryError: 'Özet oluşturulamadı. Lütfen tekrar deneyin.',
  aiSummaryGenerated: 'Yapay zeka özeti başarıyla oluşturuldu',
  aiSummaryUpdated: 'Özet başarıyla güncellendi',
  aiSummarySaveError: 'Özet kaydedilemedi',
  editSummary: 'Özeti Düzenle',
  aiQuiz: 'Yapay Zeka Quizi',
  loadingQuiz: 'Quiz yükleniyor…',
  quizLoadError: 'Quiz yüklenemedi.',
  quizNotGenerated: 'Henüz bir quiz oluşturulmadı.',
  generateQuiz: 'Quiz Oluştur',
  generatingQuiz: 'Quiz oluşturuluyor…',
  generateQuizError: 'Quiz oluşturulamadı. Lütfen tekrar deneyin.',
  quizGenerated: 'Quiz başarıyla oluşturuldu',
  publishQuizTitle: 'Quiz yayınlansın mı?',
  publishQuizBody: 'Yayınlandıktan sonra öğrenci bu quizi açıp çözebilecek.',
  publishQuiz: 'Yayınla',
  quizPublished: 'Quiz öğrenciye yayınlandı',
  publishQuizError: 'Quiz yayınlanamadı',
  studentQuizResult: 'Öğrenci Quiz Sonucu',
  score: 'Puan',
  percentage: 'Yüzde',
  quizNotAssigned: 'Henüz bir quiz atanmadı.',
  quizCompleted: 'Bu quizi tamamladınız.',
  viewResult: 'Sonucu Görüntüle',
  quizAssignedDescription: 'Mentorunuz bu dersten bir quiz atadı.',
  startQuiz: 'Quize Başla',
  legacyQuizAnswers: 'Eski quiz cevapları',
  questionLabel: 'Soru {{number}}',
  answerLabel: 'Cevap',
  correctLabel: 'doğru',
  incorrectLabel: 'yanlış',
  legacyQuizAnswersPending: 'Quiz soruları mevcut; öğrenci cevapları henüz kaydedilmedi.',
  noLegacyQuizAnswers: 'Henüz eski quiz cevabı yok.',
  legacyQuizzes: 'Eski quizler',
  noScore: 'Puan yok',
  quizPreviewTitle: 'Quiz Önizleme',
  quizEditTitle: 'Quizi Düzenle',
  quizResultTitle: 'Quiz Sonucu',
  quizTakeTitle: 'Ders Quizi',
  quizNotAvailable: 'Quiz kullanılamıyor',
  resultNotAvailable: 'Sonuç kullanılamıyor',
  submitQuizTitle: 'Quiz gönderilsin mi?',
  questionProgress: 'Soru {{current}} / {{total}}',
  messagesPageDescription: 'Bir ders hakkında mentorlar, öğrenciler ve velilerle sohbet edin.',
  messagesLoginRequired: 'Mesajlar için giriş yapın.',
  messagesLoadError: 'Mesajlar yüklenemedi',
  messagesChatFallback: 'Sohbet',
  messagesLessonThreadPrefix: 'Ders',
  messagesEmptyThreads: 'Henüz konuşma yok.',
  messagesSelectThread: 'Bir konuşma seçin.',
  messagesWritePlaceholder: 'Mesaj yazın…',
  messagesSend: 'Gönder',
  messagesParentStartRequired:
    'Bu konuşma henüz başlamadı. İlk mesajı göndermesi için veliden kendi hesabından yazmasını isteyin.',
  calendarPrevMonth: 'Önceki ay',
  calendarNextMonth: 'Sonraki ay',
  lessonsCalendarSessionsThisMonth: 'Bu ay {{count}} günde ders var',
  availabilityPageDescription: 'Haftalık çalışma saatlerinizi ve tarih istisnalarınızı yönetin.',
  availabilityTabWeeklyHours: 'Haftalık Saatler',
  availabilityTabDateOverrides: 'Tarih İstisnaları',
  availabilitySameHoursAllDays: 'Tüm günler için aynı saatler',
  availabilityAllDays: 'Tüm Günler',
  availabilityAddRange: 'Aralık ekle',
  availabilitySelectTime: 'Saat Seç',
  availabilityDayUnavailable: 'Bu gün müsait değil',
  availabilityStartTime: 'Başlangıç',
  availabilityEndTime: 'Bitiş',
  availabilityCustomHours: 'Özel saatler',
  availabilityUnavailable: 'Müsait değil',
  availabilityDateOverridesHeader: 'Tarih İstisnaları',
  availabilityLoadError: 'Müsaitlik yüklenemedi',
  availabilitySaveSuccess: 'Müsaitlik bilgileri kaydedildi.',
  availabilitySaveError: 'Kayıt başarısız. Mentor hesabı aktif ve doğrulanmış olmalı.',
  availabilityStartBeforeEnd: 'Başlangıç saati bitiş saatinden önce olmalı.',
  availabilityTimeOverlap: 'Bu zaman dilimi mevcut bir aralıkla çakışıyor.',
  apply: 'Uygula',
  bookingStepSelectDate: '1. Tarih Seçin',
  bookingStepSelectTime: '2. Saat Seçin',
  validationFirstNameRequired: 'Ad gerekli',
  validationLastNameRequired: 'Soyad gerekli',
  validationPhoneInvalid: 'Geçerli bir telefon numarası girin',
  validationBioMaxLength: 'En fazla 500 karakter',
  validationDateOfBirthPast: 'Geçmiş bir tarih seçin',
  validationDateOfBirthRequired: 'Doğum tarihi gerekli',
  materialsMentorTitle: 'Materyaller ve Ödevler',
  materialsMentorDescription: 'Öğrencileriniz için ders kaynağı veya ödev yükleyin.',
  materialsStudentTitle: 'Ödevler ve Kaynaklar',
  materialsStudentDescription: 'Mentorlarınızın atadığı materyalleri görüntüleyin.',
  materialsParentTitle: 'Çocuğun Ödevleri',
  materialsParentDescription: 'Çocuğunuza atanan materyalleri ve ödevleri görüntüleyin.',
  materialsParentNoStudentDescription: 'Ödevleri görmek için hesabınıza bir öğrenci bağlayın.',
  materialsLoadError: 'Materyaller yüklenemedi',
  materialsEmptyTitle: 'Henüz materyal yok',
  materialsEmptyMentorDescription:
    'Öğrencilerinizle paylaşmak için ilk ödevinizi veya kaynağınızı oluşturun.',
  materialsEmptyStudentDescription: 'Mentorlarınızdan gelen materyaller burada görünecek.',
  materialsEmptyParentDescription: 'Mentorlardan gelen ödevler ve kaynaklar burada görünecek.',
  materialTabAll: 'Tümü',
  materialTabAssignments: 'Ödevler',
  materialTabResources: 'Ders Kaynakları',
  materialCreate: 'Yeni Materyal',
  materialCreateTitle: 'Materyal Yükle',
  materialCreateDescription: 'Seçili öğrencilerle PDF ödev veya ders kaynağı paylaşın.',
  materialEditTitle: 'Materyali Düzenle',
  materialEditDescription:
    'Ödev ayrıntılarını, teslim tarihini veya atanan öğrencileri güncelleyin.',
  materialEdit: 'Düzenle',
  materialViewDetails: 'Detayları gör',
  materialArchive: 'Arşivle',
  materialBackToList: 'Materyallere dön',
  materialBackToDetail: 'Materyale dön',
  materialFieldTitle: 'Başlık',
  materialFieldDescription: 'Açıklama (isteğe bağlı)',
  materialFieldType: 'Tür',
  materialFieldDueDate: 'Teslim tarihi',
  materialFieldStatus: 'Durum',
  materialTypeAssignment: 'Ödev',
  materialTypeCourseResource: 'Ders Kaynağı',
  materialTitlePlaceholder: 'ör. 3. Bölüm çalışma kağıdı',
  materialDescriptionPlaceholder: 'Kısa açıklama…',
  materialAssignStudents: 'Öğrencilere ata',
  materialNoStudentsAvailable: 'Öğrenci bulunamadı. Materyal atamak için aktif ders gerekir.',
  materialUploadPdf: 'PDF yükle',
  materialPdfMaxSize: 'Yalnızca PDF. En fazla {{size}} MB.',
  materialDue: 'Teslim',
  materialCreated: 'Oluşturulma',
  materialStudents: 'öğrenci',
  materialSubmittedCount: 'Teslim: {{submitted}} / {{total}}',
  materialMissingCount: 'Eksik: {{count}}',
  materialCourseResourceHint: 'Teslim gerekmez',
  materialNoSubmissionRequired: 'Teslim gerekmez',
  materialNoFile: 'Dosya yok',
  materialStatActive: 'Aktif Materyaller',
  materialStatAssignments: 'Ödevler',
  materialStatResources: 'Ders Kaynakları',
  materialStatPending: 'Bekleyen Teslimler',
  materialStatLate: 'Geç Teslimler',
  materialSearchPlaceholder: 'Başlığa göre ara',
  materialFilterTypeLabel: 'Tür',
  materialFilterStatusLabel: 'Durum',
  materialTypeAll: 'Tümü',
  materialTabAllCount: 'Tümü ({{count}})',
  materialTabAssignmentsCount: 'Ödevler ({{count}})',
  materialTabResourcesCount: 'Ders Kaynakları ({{count}})',
  materialArchiveConfirmTitle: 'Bu materyal arşivlensin mi?',
  materialArchiveConfirmBody:
    'Öğrenciler artık bunu aktif olarak görmeyecek, ancak mevcut teslimler kullanılabilir kalacak.',
  materialArchiveConfirmAction: 'Arşivle',
  materialSelectedStudents: 'Seçili: {{count}} öğrenci',
  materialSelectAll: 'Tümünü seç',
  materialClearSelection: 'Seçimi temizle',
  materialSearchStudents: 'Öğrenci ara',
  materialPdfDropHint: 'PDF dosyasını sürükleyip bırakın veya dosya seçin',
  materialPdfConstraints: 'Yalnızca PDF · En fazla 10 MB',
  materialRemoveFile: 'Kaldır',
  materialUploadAction: 'Materyal Yükle',
  materialSaveChanges: 'Değişiklikleri Kaydet',
  materialAssignedToCount: '{{count}} öğrenciye atandı',
  materialSubmittedOf: 'Teslim {{submitted}} / {{total}}',
  materialMissingLabel: 'Eksik {{count}}',
  materialHeaderActive: 'Aktif',
  materialFilterSubmittedCount: 'Teslim edildi ({{count}})',
  materialFilterNotSubmittedCount: 'Teslim edilmedi ({{count}})',
  materialFilterLateCount: 'Geç ({{count}})',
  materialFilterAllCount: 'Tümü ({{count}})',
  earningsAndPayouts: 'Kazançlar ve Ödemeler',
  viewPublicProfile: 'Herkese Açık Profili Gör',
  profileCompletionLabel: 'Profil tamamlanma: %{{percent}}',
  profileMenuProfile: 'Profil',
  profileMenuListings: 'İlanlarım',
  profileMenuAvailability: 'Müsaitlik',
  profileMenuEarnings: 'Kazançlar',
  profileMenuNotifications: 'Bildirimler',
  profileMenuLogout: 'Çıkış yap',
  profileCurrentApproved: 'Mevcut profil: Onaylandı',
  profilePendingEditsWaiting: 'Bekleyen düzenlemeler: İnceleme bekliyor',
  profileApprovedVisibleWhileReview:
    'Son düzenlemeleriniz incelenirken onaylı profiliniz görünür kalmaya devam eder.',
  profileApprovedAndVisible: 'Herkese açık profiliniz onaylandı ve görünür.',
  profileSectionPersonal: 'Kişisel Bilgiler',
  profileSectionPublic: 'Herkese Açık Mentor Profili',
  profileSectionEarnings: 'Kazançlar ve Ödemeler',
  profileSectionPreferences: 'Hesap Tercihleri',
  profileSectionSecurity: 'Güvenlik',
  profileChecklistTitle: 'Profilinizi tamamlayın',
  profileChecklistVerified: 'Kimlik doğrulandı',
  profileChecklistEducation: 'Eğitim eklendi',
  profileChecklistSubjects: 'Konular seçildi',
  profileChecklistBio: 'Biyografi eklendi',
  profileChecklistListing: 'İlan oluşturuldu',
  profileChecklistAvailability: 'Müsaitlik ayarlandı',
  profilePrefsLanguageHint: 'Dil ve tema üst çubuktan değiştirilebilir.',
  materialCourseResourceDetailHint: 'Bu bir ders kaynağıdır. Öğrenci teslimi gerekmez.',
  materialAssignedStudents: 'Atanan öğrenciler',
  materialSubmissionTable: 'Teslim durumu',
  materialSubmissionStatus: 'Teslim durumu',
  materialYourSubmission: 'Tesliminiz',
  materialUploadSubmissionHint: 'Tamamlanmış ödevinizi PDF olarak yükleyin',
  materialPastDueWarning: 'Bu ödevin teslim tarihi geçti. Tesliminiz geç olarak işaretlenebilir.',
  materialNoSubmissionYet: 'Henüz teslim yok',
  materialNoSubmissions: 'Henüz teslim yok',
  materialSubmittedAt: 'Teslim zamanı',
  materialShowingForChild: '{{name}} için materyaller gösteriliyor',
  materialColTitle: 'Başlık',
  materialColType: 'Tür',
  materialColAssigned: 'Atanan',
  materialColDueDate: 'Teslim tarihi',
  materialColSubmissions: 'Teslimler',
  materialColCreated: 'Oluşturulma',
  materialColStatus: 'Durum',
  materialColActions: 'İşlemler',
  materialColStudent: 'Öğrenci',
  materialColParent: 'Veli',
  materialColSubmittedAt: 'Teslim zamanı',
  materialColFile: 'Dosya',
  materialFilterAll: 'Tümü',
  materialFilterSubmitted: 'Teslim edildi',
  materialFilterNotSubmitted: 'Teslim edilmedi',
  materialFilterLate: 'Geç',
  materialStatusActive: 'Aktif',
  materialStatusArchived: 'Arşivlendi',
  materialStatusNotSubmitted: 'Teslim edilmedi',
  materialStatusSubmitted: 'Teslim edildi',
  materialStatusLate: 'Geç teslim',
  materialStatusResubmitted: 'Yeniden teslim',
  materialStatusDueTomorrow: 'Yarın teslim',
  materialStatusOverdue: 'Gecikmiş',
  materialValidationTitleRequired: 'Lütfen bir başlık girin.',
  materialValidationTypeRequired: 'Lütfen ödev veya ders kaynağı seçin.',
  materialValidationPdfRequired: 'Lütfen bir PDF dosyası yükleyin.',
  materialValidationPdfOnly: 'Yalnızca PDF dosyalarına izin verilir.',
  materialValidationStudentsRequired: 'Lütfen en az bir öğrenci seçin.',
  materialValidationDueDateRequired: 'Bu ödev için lütfen bir teslim tarihi seçin.',
  materialValidationFileTooLarge: 'Dosya çok büyük.',
  materialCreatedSuccess: 'Materyal başarıyla oluşturuldu.',
  materialUpdatedSuccess: 'Materyal başarıyla güncellendi.',
  materialArchivedSuccess: 'Materyal arşivlendi.',
  materialArchiveFailed: 'Materyal arşivlenemedi.',
  materialCreateFailed: 'Materyal oluşturulamadı.',
  materialUpdateFailed: 'Materyal güncellenemedi.',
  materialSubmissionSuccess: 'Ödev başarıyla teslim edildi.',
  materialSubmissionFailed: 'Teslim başarısız.',
  materialDueDateChangeTitle: 'Teslim tarihi değiştirilsin mi?',
  materialDueDateChangeMessage:
    'Teslim tarihini değiştirmek, öğrenciler ve veliler için hatırlatma bildirimlerini güncelleyecektir.',
  openPdf: 'PDF Aç',
  downloadPdf: 'PDF İndir',
  openTeacherPdf: "Öğretmen PDF'ini aç",
  downloadTeacherPdf: "Öğretmen PDF'ini indir",
  openSubmittedPdf: "Teslim edilen PDF'i aç",
  downloadSubmittedPdf: "Teslim edilen PDF'i indir",
  materialPdfUnavailable: 'PDF bağlantısı kullanılamıyor.',
  materialColChild: 'Çocuk',
  submitAssignment: 'Ödevi Teslim Et',
  reuploadSubmission: 'Teslimi Yeniden Yükle',
  notificationOpenThread: 'Konuşmayı aç →',
  notificationOpenAssignment: 'Ödevi aç →',
  notificationAssignmentReminderTitle: 'Ödev hatırlatması',
  notificationParentReminderTitle: 'Hatırlatma',
  notificationMissingSubmissionsTitle: 'Eksik teslimler',
  notificationAssignmentDue3DaysStudent:
    'Ödev hatırlatması: "{{title}}" 3 gün içinde teslim edilecek.',
  notificationAssignmentDue1DayStudent: 'Ödev hatırlatması: "{{title}}" yarın teslim edilecek.',
  notificationAssignmentDue3DaysParent:
    'Hatırlatma: Çocuğunuzun "{{title}}" ödevi 3 gün içinde teslim edilecek.',
  notificationAssignmentDue1DayParent:
    'Hatırlatma: Çocuğunuzun "{{title}}" ödevi yarın teslim edilecek.',
  notificationAssignmentMissingParent: 'Çocuğunuz "{{title}}" ödevini teslim etmedi.',
  notificationAssignmentMissingMentor: '{{count}} öğrenci {{title}} ödevini teslim etmedi',
  adminPanelTitle: 'Yönetim Paneli',
  adminMenuAria: 'Yönetim menüsü',
  adminForbiddenTitle: 'Erişim reddedildi',
  adminForbiddenBody: 'Yönetim paneline erişim yetkiniz yok.',
  adminGoHome: 'Ana sayfaya dön',
  adminNavDashboard: 'Panel',
  adminNavVerifications: 'Mentor Doğrulamaları',
  adminNavProfiles: 'Mentor Profilleri',
  adminNavListings: 'İlanlar',
  adminNavMedia: 'Medya',
  adminNavReviews: 'Yorumlar',
  adminNavSuccessStories: 'Başarı Hikayeleri',
  adminNavReports: 'Raporlar',
  adminNavUsers: 'Kullanıcılar',
  adminNavAuditLogs: 'Denetim Kayıtları',
  adminDashboardSubtitle: 'Operasyonel özet',
  adminDashboardLoadError: 'Panel istatistikleri yüklenemedi.',
  adminStatTotalUsers: 'Toplam kullanıcı',
  adminStatMentors: 'Mentorlar',
  adminStatSuspended: 'Askıya alınan',
  adminStatPendingVerifications: 'Bekleyen doğrulamalar',
  adminStatPendingProfiles: 'Bekleyen profil incelemeleri',
  adminStatProfileRevisions: 'Bekleyen revizyonlar',
  adminStatHiddenProfiles: 'Gizli profiller',
  adminStatPendingListings: 'Bekleyen ilanlar',
  adminStatHiddenListings: 'Gizli ilanlar',
  adminVerificationsSubtitle: 'Kimlik ve öğrenci doğrulamasını inceleyin',
  adminVerificationsLoadError: 'Doğrulamalar yüklenemedi.',
  adminVerificationsEmpty: 'Bekleyen mentor doğrulaması yok.',
  adminColStudentVerification: 'Öğrenci doğrulama',
  adminColIdentityVerification: 'Kimlik doğrulama',
  adminColAccessStatus: 'Erişim durumu',
  adminColSubmitted: 'Gönderim',
  adminColActions: 'İşlemler',
  adminMoreActions: 'Diğer işlemler',
  adminColModerationStatus: 'Moderasyon',
  adminColPendingRevision: 'Bekleyen revizyon',
  adminColMentor: 'Mentor',
  adminColListing: 'İlan',
  adminColLessonFormat: 'Format',
  adminColAvailability: 'Müsaitlik',
  adminColName: 'Ad',
  adminColAccountStatus: 'Hesap durumu',
  adminColCreated: 'Oluşturulma',
  adminColReviewed: 'İncelenme',
  adminView: 'Görüntüle',
  adminApprove: 'Onayla',
  adminReject: 'Reddet',
  adminHide: 'Gizle',
  adminRestore: 'Geri yükle',
  adminRequestChanges: 'Değişiklik iste',
  adminReasonPlaceholder: 'Bir neden girin…',
  adminPageOf: 'Sayfa {{page}} / {{total}}',
  adminPrevPage: 'Önceki',
  adminNextPage: 'Sonraki',
  adminActionApproved: 'Başarıyla onaylandı.',
  adminActionRejected: 'Başarıyla reddedildi.',
  adminActionSaved: 'Değişiklikler kaydedildi.',
  adminActionRestored: 'Başarıyla geri yüklendi.',
  adminActionFailed: 'İşlem başarısız. Lütfen tekrar deneyin.',
  adminVerificationLoadError: 'Doğrulama detayları yüklenemedi.',
  adminMentorInfo: 'Mentor bilgileri',
  adminUploadedDocuments: 'Yüklenen belgeler',
  adminNoDocuments: 'Belge yüklenmemiş.',
  adminViewDocument: 'Belgeyi görüntüle',
  adminApproveVerificationTitle: 'Doğrulamayı onayla?',
  adminApproveVerificationBody: 'Gereksinimler karşılanıyorsa mentor tam erişim kazanır.',
  adminRejectVerificationTitle: 'Doğrulamayı reddet',
  adminProfilesSubtitle: 'İlk profilleri ve bekleyen revizyonları inceleyin',
  adminProfilesLoadError: 'Mentor profilleri yüklenemedi.',
  adminProfilesEmpty: 'Filtrelere uyan profil yok.',
  adminProfileLoadError: 'Mentor profili yüklenemedi.',
  adminPublishedProfile: 'Yayınlanan profil',
  adminPendingRevision: 'Bekleyen revizyon',
  adminProfessionalTitle: 'Profesyonel unvan',
  adminHourlyRate: 'Saatlik ücret',
  adminApproveProfile: 'Profili onayla',
  adminApproveRevision: 'Revizyonu onayla',
  adminApproveProfileTitle: 'Profili onayla?',
  adminApproveProfileBody: 'Profil herkese açık hale gelir (diğer kurallara tabi).',
  adminRestoreProfileTitle: 'Profili geri yükle?',
  adminRestoreProfileBody: 'Profil onaylı görünürlüğe döner.',
  adminRequestChangesTitle: 'Değişiklik iste',
  adminRejectProfileTitle: 'Profili reddet',
  adminHideProfileTitle: 'Profili gizle',
  adminListingsSubtitle: 'Mentor ilanlarını inceleyin ve yönetin',
  adminListingsLoadError: 'İlanlar yüklenemedi.',
  adminListingsEmpty: 'Filtrelere uyan ilan yok.',
  adminListingLoadError: 'İlan yüklenemedi.',
  adminApproveListingTitle: 'İlanı onayla?',
  adminApproveListingBody: 'Müsaitlik aktifse ilan herkese açık olabilir.',
  adminRestoreListingTitle: 'İlanı geri yükle?',
  adminRestoreListingBody: 'İlan onaylı duruma döner.',
  adminRejectListingTitle: 'İlanı reddet',
  adminHideListingTitle: 'İlanı gizle',
  adminUsersSubtitle: 'Kullanıcı hesaplarını askıya alın veya etkinleştirin',
  adminUsersLoadError: 'Kullanıcılar yüklenemedi.',
  adminUsersEmpty: 'Filtrelere uyan kullanıcı yok.',
  adminUserLoadError: 'Kullanıcı yüklenemedi.',
  adminSuspendUser: 'Kullanıcıyı askıya al',
  adminReactivateUser: 'Kullanıcıyı etkinleştir',
  adminSuspendUserTitle: 'Kullanıcıyı askıya al',
  adminReactivateUserTitle: 'Kullanıcıyı etkinleştir?',
  adminReactivateUserBody: 'Kullanıcı platforma tekrar erişebilir.',
  adminUserSuspended: 'Kullanıcı askıya alındı.',
  adminUserReactivated: 'Kullanıcı etkinleştirildi.',
  adminFilterAllStatuses: 'Tüm durumlar',
  adminFilterAllReviewTypes: 'Tüm inceleme türleri',
  adminFilterAllRoles: 'Tüm roller',
  adminStatusPendingReview: 'İnceleme bekliyor',
  adminStatusApproved: 'Onaylandı',
  adminStatusChangesRequested: 'Değişiklik istendi',
  adminStatusRejected: 'Reddedildi',
  adminStatusHidden: 'Yönetici tarafından gizlendi',
  adminStatusActive: 'Aktif',
  adminStatusSuspended: 'Askıya alındı',
  adminReviewInitial: 'İlk başvuru',
  adminReviewRevision: 'Profil revizyonu',
  adminRoleAdmin: 'Yönetici',
  yes: 'Evet',
  no: 'Hayır',
  mentorUnavailable: 'Bu mentor profili artık mevcut değil.',
  listingUnavailable: 'Bu ilan artık mevcut değil.',
  savedMentorUnavailable: 'Bu mentor şu anda müsait değil.',
  profileModerationStatus: 'Profil moderasyonu',
  listingModerationStatus: 'İlan moderasyonu',
  profilePendingRevisionNotice:
    'Mevcut profiliniz hâlâ görünür. Düzenlediğiniz profil inceleme bekliyor.',
  listingSubmittedForReview:
    'İlan inceleme için gönderildi. Yönetici onayından sonra herkese açık olacak.',
  listingDescriptionSentForReview: 'İlan açıklamanız güncellendi ve incelemeye gönderildi.',
  listingUpdatedNoReview: 'İlan başarıyla güncellendi.',
  availabilityUpdated: 'Müsaitlik başarıyla güncellendi.',
  cannotToggleHiddenListing: 'Bu ilan yönetim tarafından gizlendi ve etkinleştirilemez.',
  moderationStatusDraft: 'Taslak',
  moderationStatusPendingReview: 'İnceleme bekliyor',
  moderationStatusApproved: 'Onaylandı',
  moderationStatusChangesRequested: 'Değişiklik istendi',
  moderationStatusRejected: 'Reddedildi',
  moderationStatusHidden: 'Yönetici tarafından gizlendi',
  navMentorDiscovery: 'Mentor Keşfet',
  discoveryPageTitle: 'Mentorunu Bul',
  discoveryPageSubtitle:
    'Onaylı mentorlar arasında gezin ve öğrenme yolculuğun için doğru eşleşmeyi bul.',
  discoverySearchPlaceholder: 'Ders veya mentor adı ara',
  savedMentors: 'Kayıtlı mentorlar',
  savedMentorsSubtitle: 'Sonra bakmak için kaydettiğin mentorlar',
  backToDiscovery: 'Keşfe dön',
  backToSearch: 'Aramaya dön',
  startDiscovery: 'Keşfe başla',
  noSavedMentors: 'Henüz kayıtlı mentor yok',
  noSavedMentorsHint: 'Gezinirken mentorları kaydederek burada bulabilirsin.',
  discoveryEndOfFeed: 'Bu gruptaki tüm mentorları görüntüledin.',
  discoveryEndOfFeedHint: 'Daha fazla mentor yükle veya baştan başla.',
  discoveryAllSeenTitle: 'Şu an yeni mentor yok',
  discoveryAllSeenHint:
    'Keşifte uygun tüm mentorları zaten görüntülemiş olabilirsin. Tekrar göster veya mentor aramasını dene.',
  discoveryShowAgain: 'Mentorları tekrar göster',
  discoveryStartOver: 'Baştan başla',
  discoveryBrowseSearch: 'Mentor aramasına git',
  discoveryCardProgress: '{{current}} / {{total}}',
  discoveryViewProfile: 'Profili görüntüle',
  discoverySaveForLater: 'Sonra için kaydet',
  discoveryPrevious: 'Önceki',
  discoveryNext: 'Sonraki',
  noMentorsFoundFilters: 'Bu filtrelerle eşleşen mentor bulunamadı.',
  tryChangingFilters: 'Ders, sınıf düzeyi veya öğretim formatını değiştirmeyi dene.',
  subjects: 'Dersler',
  teachingStyle: 'Öğretim tarzı',
  verified: 'Doğrulandı',
  reviews: 'değerlendirme',
  parentReview: 'Veli yorumu',
  successStory: 'Başarı',
  skip: 'Geç',
  liked: 'Beğenildi',
  skipMentor: 'Mentoru geç',
  likeMentor: 'Mentoru beğen',
  saveMentor: 'Mentoru kaydet',
  unsaveMentor: 'Kaydı kaldır',
  openMentorProfile: 'Profili aç',
  viewProfile: 'Profili gör',
  removeFromSaved: 'Kayıtlılardan kaldır',
  mentorSaved: 'Mentor kaydedildi',
  mentorUnsaved: 'Kayıttan kaldırıldı',
  likedMentorTitle: 'Beğenildi!',
  likedMentorHint: 'Bu mentorla deneme dersi talep etmek ister misin?',
  continueBrowsing: 'Gezmeye devam et',
  requestTrialLesson: 'Deneme dersi talep et',
  filters: 'Filtreler',
  applyFilters: 'Filtreleri uygula',
  clearAll: 'Tümünü temizle',
  examType: 'Sınav türü',
  gradeLevel: 'Sınıf düzeyi',
  teachingFormat: 'Öğretim formatı',
  minRating: 'Minimum puan',
  allFormats: 'Tüm formatlar',
  anyRating: 'Herhangi bir puan',
  anyFormat: 'Herhangi bir format',
  formatOnline: 'Çevrimiçi',
  formatInPerson: 'Yüz yüze',
  formatHybrid: 'Hibrit',
  actionFailed: 'Bir şeyler ters gitti. Lütfen tekrar dene.',
  contactMentorTitle: 'Mentora ulaş',
  contactMentorIntro: '{name} adlı mentora talep gönder. İnceleyip yanıt verecek.',
  requestType: 'Talep türü',
  requestTypeTrial: 'Deneme dersi',
  requestTypeContact: 'İletişim',
  requestTypeRegular: 'Düzenli ders',
  fieldRequired: 'Bu alan zorunludur',
  preferredDays: 'Tercih edilen günler',
  preferredDaysHint: 'ör. Pazartesi, Çarşamba',
  preferredTimeSlots: 'Tercih edilen saatler',
  preferredTimeSlotsHint: 'ör. 18:00-20:00',
  contactMessagePlaceholder: 'Mentora ne tür destek aradığını anlat.',
  messageLabel: 'Mesaj',
  sendRequest: 'Talebi gönder',
  close: 'Kapat',
  contactRequestSuccessTitle: 'Talebin başarıyla gönderildi.',
  contactRequestSuccessBody: 'Mentor yanıt verdiğinde seni bilgilendireceğiz.',
  contactNoLinkedStudents:
    'Mentor talebi göndermeden önce bağlı bir öğrenci eklemen gerekir. Öğrencilerim sayfasından öğrenci oluştur veya bağla.',
  leaveAReview: 'Değerlendirme yap',
  referenceModalTitle: 'Deneyimini paylaş',
  referenceTypeReview: 'Değerlendirme',
  referenceTypeSuccessStory: 'Başarı hikayesi',
  referenceTitleLabel: 'Başlık (isteğe bağlı)',
  referenceContentLabel: 'Değerlendirmeniz',
  referenceContentHint: 'En az 10 karakter.',
  referenceRatingLabel: 'Puan (isteğe bağlı)',
  referenceAchievementNameLabel: 'Başarı',
  referenceAchievementNamePlaceholder: "ör. XYZ Üniversitesi'ne kabul edildi",
  referenceAchievementYearLabel: 'Yıl',
  referenceDisplayNameLabel: 'Adımı şu şekilde göster',
  referenceDisplayAsParent: 'Bir Veli',
  referenceDisplayAsStudent: 'Bir Öğrenci',
  referenceDisplayAsAnonymous: 'Anonim',
  referenceDisplayCustomOption: 'Özel',
  referenceDisplayCustomPlaceholder: 'Bir görünen ad girin',
  referenceConsentLabel:
    'Bu değerlendirmenin mentor profilinde herkese açık olarak gösterilmesini kabul ediyorum.',
  referenceSubmit: 'Değerlendirmeyi gönder',
  referenceSubmitSuccessTitle: 'Teşekkürler!',
  referenceSubmitSuccessBody: 'Değerlendirmeniz gönderildi ve mentor onayladıktan sonra görünecek.',
  referenceSubmitFailed: 'Değerlendirmeniz gönderilemedi',
  referenceContentTooShort: 'Lütfen en az 10 karakter yazın',
  referenceConsentRequired: 'Göndermek için bu değerlendirmenin gösterilmesini kabul etmelisiniz',
  mentorReferencesTitle: 'Referanslar',
  mentorReferencesSubtitle: 'Hakkınızda gönderilen değerlendirmeler ve başarı hikayeleri.',
  referencesTabPending: 'Bekleyen',
  referencesTabApproved: 'Onaylanan',
  referencesTabHidden: 'Gizlenen',
  referenceApprove: 'Onayla',
  referenceHide: 'Gizle',
  referencesEmpty: 'Burada henüz referans yok.',
  referenceUpdateFailed: 'Bu referans güncellenemedi',
  referencesLoadFailed: 'Referanslar yüklenemedi',
  navReferences: 'Referanslar',
  completeVerification: 'Doğrulamayı tamamla',
  verificationOnboardingTitle: 'Doğrulanın',
  verificationOnboardingSubtitle:
    'Mentor panelinizin tamamının kilidini açmak için bu adımları tamamlayın.',
  verificationStepEmail: 'E-posta doğrulandı',
  verificationStepIdentity: 'Kimlik doğrulama',
  verificationStepDocuments: 'Akademik kanıt',
  verificationSkipForNow: 'Şimdilik atla',
  verificationContinue: 'Devam et',
  verificationEmailConfirmed: 'E-postanız onaylandı: {{email}}',
  verificationIdentityVerifiedMsg: 'Kimliğiniz doğrulandı.',
  verificationIdentityInProgress: 'Kimlik doğrulama sürüyor.',
  verificationIdentityFailedMsg: 'Doğrulama başarısız oldu — lütfen tekrar deneyin.',
  verificationIdentityPrompt: 'Güvenli ortağımız aracılığıyla yasal kimliğinizi doğrulayın.',
  verificationAcademicLocked: 'Bu adımın kilidini açmak için önce kimliğinizi doğrulayın.',
  verificationStudentEmailAutoApproved:
    'Üniversite e-postanız otomatik onaylandı — yükleme gerekmez.',
  verificationAcademicApproved: 'Akademik belgeniz onaylandı.',
  verificationAcademicUnderReview: 'Akademik belgeniz inceleniyor.',
  verificationAcademicRejected: 'Akademik belgeniz reddedildi.',
  verificationAcademicRejectedWithNotes: 'Akademik belgeniz reddedildi: {{notes}}',
  verificationAcademicUploadPrompt: 'Devam etmek için akademik belgenizi yükleyin.',
  verificationInfoRestrictedIdentity:
    'Panonuzun, derslerinizin, materyallerinizin, kazançlarınızın ve diğer mentor özelliklerinin kilidini açmak için kimlik doğrulamanızı tamamlayın.',
  verificationInfoPendingReview:
    'Bu inceleme tamamlanana kadar panonuz ve diğer mentor özellikleri kilitli kalır.',
  verificationInfoRestrictedOther:
    'Panonuzun ve diğer mentor özelliklerinin kilidini açmak için yukarıdaki adımları tamamlayın.',
  verificationCheckStatus: 'Doğrulama durumunu kontrol et',
  verificationVerifyIdentityButton: 'Kimliği doğrula',
  verificationIllDoLater: 'Bunu daha sonra yapacağım',
  verificationStatusNotStarted: 'Başlamadı',
  verificationStatusPending: 'İnceleniyor',
  verificationStatusVerified: 'Doğrulandı',
  verificationStatusFailed: 'Başarısız',
  verificationStatusApproved: 'Onaylandı',
  verificationStatusRejected: 'Reddedildi',
  verificationStatusNotRequired: 'Gerekli değil',
  verificationFullyActive: 'Doğrulandı ve aktif',
  verificationFullyActiveBody: 'Hesabınız tamamen doğrulandı. Tüm mentor özellikleri açıldı.',
  verificationActionRequired: 'İşlem gerekli',
  verificationPendingReviewBadge: 'İnceleniyor',
  verificationAcademicComplete: 'Akademik doğrulama tamamlandı',
  verificationPanelTitle: 'Doğrulama durumu',
  identityVerificationTitle: 'Kimlik doğrulama',
  identityVerificationBody:
    'Veliler ve öğrencilerle güven oluşturmak için kimliğinizi doğrulayın. Bu, yeni bir sekmede güvenli bir doğrulama oturumu açar.',
  identityStartButton: 'Doğrulamayı başlat',
  identityRestartButton: 'Doğrulamayı yeniden başlat',
  identityRefreshStatus: 'Durumu yenile',
  identityOpenedHint:
    'Doğrulamayı yeni sekmede tamamlayın, ardından buraya dönüp durumunuzu yenileyin.',
  documentUploadTitle: 'Akademik kanıt',
  documentUploadBody:
    'Akademik geçmişinizi kanıtlayan bir belge yükleyin (mezuniyet belgesi, diploma veya kayıt belgesi).',
  documentTypeGraduationCertificate: 'Mezuniyet belgesi',
  documentTypeDiploma: 'Diploma',
  documentTypeEnrollmentLetter: 'Kayıt belgesi',
  documentTypeOther: 'Diğer',
  documentUploadButton: 'Belge yükle',
  documentUploadHint: 'PDF, JPEG, PNG veya WEBP, en fazla 8MB.',
  documentFileTooLarge: 'Dosya çok büyük. Maksimum boyut 8MB.',
  documentFileTypeInvalid: 'Desteklenmeyen dosya türü. PDF, JPEG, PNG veya WEBP kullanın.',
  documentUploadFailed: 'Belge yüklenemedi',
  documentUploadSuccess: 'Belge yüklendi — inceleme bekleniyor.',
  documentsListTitle: 'Yüklemeleriniz',
  documentsEmpty: 'Henüz belge yüklenmedi.',
  verificationStatusLoadFailed: 'Doğrulama durumu yüklenemedi',
  identityStartFailed: 'Kimlik doğrulama başlatılamadı',
  navPricing: 'Fiyatlandırma',
  navMediaGallery: 'Medya Galerisi',
  mediaGalleryTitle: 'Medya Galerisi',
  mediaGalleryDescription:
    'Herkese açık profilinizde gösterilen fotoğrafları ve tanıtım videosunu yönetin.',
  mentorPricingTitle: 'Fiyatlandırma',
  mentorPricingSubtitle: 'Saatlik ücretinizi ve ders paketlerinizi belirleyin.',
  pricingCurrencyLabel: 'Para birimi',
  pricingHourlyRateLabel: 'Saatlik ücret',
  pricingTrialPriceLabel: 'Deneme dersi ücreti',
  pricingPublicToggleLabel: 'Fiyatlandırmamı profilimde herkese açık göster',
  pricingPackagesTitle: 'Paketler',
  pricingPackageNameLabel: 'Paket adı',
  pricingPackageLessonsLabel: 'Ders sayısı',
  pricingPackagePriceLabel: 'Fiyat',
  pricingAddPackage: 'Paket ekle',
  pricingRemovePackage: 'Kaldır',
  pricingSave: 'Fiyatlandırmayı kaydet',
  pricingSaveSuccess: 'Fiyatlandırma güncellendi',
  pricingSaveFailed: 'Fiyatlandırma güncellenemedi',
  mentorMediaGalleryTitle: 'Profil fotoğrafları',
  mentorMediaGalleryHint: 'En fazla 5 fotoğraf. JPG, PNG veya WebP, her biri en fazla 5MB.',
  mentorMediaUpload: 'Fotoğraf yükle',
  mentorMediaPrimaryBadge: 'Birincil',
  mentorMediaDelete: 'Sil',
  mentorMediaUploadFailed: 'Fotoğraf yüklenemedi',
  mentorMediaDeleteFailed: 'Fotoğraf silinemedi',
  mentorMediaMaxReached: 'En fazla 5 fotoğraf sınırına ulaştınız',
  mentorMediaEmpty: 'Henüz fotoğraf yüklenmedi.',
  mentorMediaCount: '{{count}} fotoğraf yüklendi',
  introVideoTitle: 'Tanıtım videosu',
  introVideoHint:
    'Kısa bir tanıtım videosu dosyasının doğrudan bağlantısını ekleyin (.mp4, .webm — YouTube veya Vimeo sayfa bağlantısı değil). Herkese açık profilinizde görünmeden önce incelenecektir.',
  introVideoUrlLabel: "Video URL'si",
  introVideoUrlPlaceholder: 'https://...',
  introVideoUrlInvalid: "Geçerli bir video URL'si girin",
  introVideoReplace: 'Değiştir',
  introVideoSaveSuccess: 'Tanıtım videosu incelemeye gönderildi',
  introVideoSaveFailed: 'Tanıtım videosu kaydedilemedi',
  reportProfile: 'Profili bildir',
  reportReason: 'Sebep',
  reportReasonInappropriate: 'Uygunsuz içerik',
  reportReasonFalseInfo: 'Yanlış bilgi',
  reportReasonSafety: 'Güvenlik endişesi',
  reportReasonSpam: 'Spam',
  reportReasonOther: 'Diğer',
  additionalDetails: 'Ek açıklama (isteğe bağlı)',
  submitReport: 'Bildirimi gönder',
  reportSubmitted: 'Bildirim gönderildi',
  reportThankYou: 'Teşekkürler. Ekibimiz bu bildirimi inceleyecek.',
  subjectField: 'Ders',
  department: 'Bölüm',
  degree: 'Derece',
  graduationYear: 'Mezuniyet yılı',
  highSchool: 'Lise',
  professionalTitle: 'Unvan',
  professionalTitlePlaceholder: 'ör. Matematik Öğretmeni, Yazılım Mühendisi',
  profileSlogan: 'Profil sloganı',
  longBio: 'Detaylı biyografi',
  longBioPlaceholder:
    'Öğrencilere öğretim geçmişiniz ve yaklaşımınız hakkında daha fazla bilgi verin.',
  teachingExperience: 'Öğretim deneyimi',
  teachingExperiencePlaceholder: 'ör. 5 yıllık matematik özel dersi',
  certifications: 'Sertifikalar',
  addCertificationPlaceholder: 'Bir sertifika ekleyin',
  add: 'Ekle',
  teachingFormats: 'Ders formatları',
  teachingFormatOnline: 'Çevrimiçi',
  teachingFormatInPerson: 'Yüz yüze',
  teachingFormatHybrid: 'Hibrit',
  teachingStyleTagPatient: 'Sabırlı',
  teachingStyleTagMotivating: 'Motive edici',
  teachingStyleTagDisciplined: 'Disiplinli',
  teachingStyleTagFriendly: 'Arkadaş canlısı',
  teachingStyleTagExamOriented: 'Sınav odaklı',
  teachingStyleTagSupportive: 'Destekleyici',
  teachingStyleTagStructured: 'Yapılandırılmış',
  teachingStyleTagFun: 'Eğlenceli',
  teachingStyleTagCalm: 'Sakin',
  teachingStyleTagEnergetic: 'Enerjik',
  teachingStyleTagGoalOriented: 'Hedef odaklı',
  expertise: 'Uzmanlık',
  introVideo: 'Tanıtım videosu',
  playVideo: 'Videoyu oynat',
  noReviewsYet: 'Henüz yorum yok.',
  successStories: 'Başarı hikayeleri',
  noSuccessStories: 'Henüz başarı hikayesi yok.',
  pricing: 'Ücretlendirme',
  hourlyRate: 'Saatlik ücret',
  pricingHidden: 'Ücret bilgisi talepten sonra paylaşılacak.',
  myMentorRequests: 'Mentor taleplerim',
  myMentorRequestsSubtitle: 'İletişim ve deneme dersi taleplerini takip et',
  noMentorRequests: 'Henüz mentor talebi göndermedin.',
  noMentorRequestsHint: 'Başlamak için bir mentor profilinden deneme dersi talep et.',
  loadError: 'Bir şeyler ters gitti. Lütfen tekrar dene.',
  created: 'Oluşturulma',
  cancelRequest: 'Talebi iptal et',
  requestCancelled: 'Talep iptal edildi',
  mentorContactRequests: 'İletişim Talepleri',
  mentorContactRequestsSubtitle:
    'Velilerden ve öğrencilerden gelen talepleri inceleyin ve yönetin.',
  noIncomingRequests: 'Gelen talep yok.',
  rejectRequest: 'Talebi reddet',
  requestAccepted: 'Talep kabul edildi',
  requestRejected: 'Talep reddedildi',
  acceptRequest: 'Kabul et',
  rejectRequestBtn: 'Reddet',
  markCompleted: 'Tamamlandı işaretle',
  statusPending: 'Beklemede',
  statusAccepted: 'Kabul edildi',
  statusRejected: 'Reddedildi',
  statusCancelled: 'İptal edildi',
  statusCompleted: 'Tamamlandı',
  contactRequestsTabAll: 'Tümü',
  contactRequestsSearchPlaceholder: 'Öğrenci veya veli adına göre ara',
  contactRequestsFilterSubjectAll: 'Tüm dersler',
  contactRequestsFilterGradeAll: 'Tüm sınıflar',
  contactRequestsSortLabel: 'Sırala',
  contactRequestsSortNewest: 'En yeni',
  contactRequestsSortOldest: 'En eski',
  contactRequestParentLabel: 'Veli: {{name}}',
  contactRequestViewDetails: 'Detayları görüntüle',
  contactRequestDetailsTitle: 'Talep detayları',
  contactRequestSubmittedLabel: 'Gönderildi',
  contactRequestStatusLabel: 'Durum',
  contactRequestMentorResponseLabel: 'Yanıtınız',
  contactRequestRespondedAtLabel: 'Yanıtlandı',
  contactRequestNoMessage: 'Mesaj belirtilmedi.',
  contactRequestsEmptyAllTitle: 'Henüz talep yok',
  contactRequestsEmptyAllBody: 'Velilerden ve öğrencilerden gelen yeni talepler burada görünecek.',
  contactRequestsEmptyPendingTitle: 'Bekleyen talep yok',
  contactRequestsEmptyPendingBody:
    'Velilerden ve öğrencilerden gelen yeni talepler burada görünecek.',
  contactRequestsEmptyStatusTitle: 'Bu durumda henüz talep yok',
  contactRequestsEmptyStatusBody: 'Bu duruma sahip talepler burada görünecek.',
  contactRequestsEmptyFilteredTitle: 'Filtrelerinize uyan talep yok',
  contactRequestsEmptyFilteredBody: 'Farklı bir arama terimi deneyin veya filtreleri temizleyin.',
  adminContactRequests: 'Mentor iletişim talepleri',
  adminContactRequestsSubtitle: 'Tüm iletişim taleplerini görüntüle ve yönet',
  adminNoContactRequests: 'İletişim talebi bulunamadı.',
  adminActionSuccess: 'Başarıyla güncellendi.',
  adminReportsSubtitle: 'Kullanıcı bildirimlerini incele',
  adminNoReports: 'Bildirim bulunamadı.',
  reportStatusOpen: 'Açık',
  reportStatusUnderReview: 'İncelemede',
  reportStatusResolved: 'Çözüldü',
  reportStatusDismissed: 'Reddedildi',
  markUnderReview: 'İncelemeye al',
  resolve: 'Çöz',
  dismiss: 'Kapat',
  mentorLabel: 'Mentor',
  adminNavMarketing: 'Pazarlama Yönetimi',
  marketingCampaignsSubtitle: 'Sponsorlu eğitim kampanyalarını oluşturun ve yönetin',
  marketingCampaignsLoadError: 'Kampanyalar yüklenemedi.',
  marketingCampaignsEmpty: 'Henüz kampanya yok.',
  marketingCreateCampaign: 'Kampanya oluştur',
  marketingCreateSubtitle: 'Yerleşim, hedefleme ve takvim ayarlarını yapın.',
  marketingEditCampaign: 'Kampanyayı düzenle',
  marketingCampaignDetail: 'Kampanya detayı',
  marketingCampaignLoadError: 'Kampanya yüklenemedi.',
  marketingCampaignCreated: 'Kampanya oluşturuldu.',
  marketingCampaignUpdated: 'Kampanya güncellendi.',
  marketingCampaignPaused: 'Kampanya duraklatıldı.',
  marketingCampaignEnded: 'Kampanya sonlandırıldı.',
  marketingCampaignDeleted: 'Kampanya arşivlendi.',
  marketingDeleteTitle: 'Kampanya arşivlensin mi?',
  marketingDeleteBody: 'Bu kampanya artık kullanıcılara gösterilmeyecek.',
  marketingMetrics: 'Metrikler',
  marketingMetricsLoadError: 'Kampanya metrikleri yüklenemedi.',
  marketingMetricsByPlacement: 'Yerleşime göre',
  marketingMetricsByPlatform: 'Platforma göre',
  marketingMetricsStartDate: 'Başlangıç tarihi',
  marketingMetricsEndDate: 'Bitiş tarihi',
  marketingMetricsDateRange: 'Tarih aralığı',
  marketingNoMetrics: 'Bu aralık için metrik yok.',
  marketingColCampaignName: 'Kampanya',
  marketingColSponsor: 'Sponsor',
  marketingColDates: 'Takvim',
  marketingColPlacements: 'Yerleşimler',
  marketingColRoles: 'Hedef roller',
  marketingColImpressions: 'Gösterim',
  marketingColClicks: 'Tıklama',
  marketingColCtr: 'TO',
  marketingColPerformance: 'Performans',
  marketingActionPause: 'Duraklat',
  marketingActionActivate: 'Etkinleştir',
  marketingActionEnd: 'Sonlandır',
  marketingPauseBeforeEdit: 'Düzenlemeden önce duraklat',
  marketingStatusDraft: 'Taslak',
  marketingStatusActive: 'Aktif',
  marketingStatusPaused: 'Duraklatıldı',
  marketingStatusDeleted: 'Arşivlendi',
  marketingStatusEnded: 'Sona erdi',
  marketingSectionBasicInfo: 'Temel bilgiler',
  marketingSectionPlacements: 'Bu kampanya nerede görünsün?',
  marketingSectionTargeting: 'Hedefleme',
  marketingSectionSchedule: 'Takvim ve durum',
  marketingPlacementsHint: 'Sponsorlu kartın görünebileceği ekranları seçin.',
  marketingFieldInternalName: 'Kampanya adı (dahili)',
  marketingFieldTitle: 'Kart başlığı',
  marketingFieldSubtitle: 'Alt başlık',
  marketingFieldDescription: 'Açıklama',
  marketingFieldImageUrl: 'Kampanya görseli URL',
  marketingFieldSponsorLabel: 'Sponsor / şirket adı',
  marketingFieldBadgeText: 'Sponsorlu etiket metni',
  marketingFieldCtaText: 'CTA düğme metni',
  marketingFieldCtaUrl: 'CTA bağlantı URL',
  marketingFieldLanguage: 'Dil',
  marketingFieldGeneralCampaign: 'Genel kampanya (sınıf/ders hedeflemesi yok)',
  marketingFieldTargetGrade: 'Hedef sınıf',
  marketingFieldTargetSubject: 'Hedef ders',
  marketingFieldTargetExam: 'Hedef sınav türü',
  marketingFieldMinAge: 'Minimum yaş',
  marketingFieldMaxAge: 'Maksimum yaş',
  marketingFieldStartDate: 'Başlangıç tarihi',
  marketingFieldEndDate: 'Bitiş tarihi',
  marketingFieldStatus: 'Durum',
  marketingFieldPlatform: 'Platform',
  marketingFieldPriority: 'Öncelik',
  marketingFieldPriorityValue: 'Öncelik (0–100)',
  marketingLanguageEn: 'İngilizce',
  marketingLanguageTr: 'Türkçe',
  marketingPlatformWeb: 'Web',
  marketingPlatformIos: 'iOS',
  marketingPlatformAndroid: 'Android',
  marketingPlatformAll: 'Tüm platformlar',
  marketingPriorityLow: 'Düşük',
  marketingPriorityNormal: 'Normal',
  marketingPriorityHigh: 'Yüksek',
  marketingPriorityCustom: 'Özel',
  marketingRoleParent: 'Veli',
  marketingRoleStudent: 'Öğrenci',
  marketingRoleMentor: 'Mentor',
  marketingPlacementSearchResults: 'Mentor arama sonuçları',
  marketingPlacementDiscoveryFeed: 'Mentor keşfi',
  marketingPlacementLessonsPage: 'Rezervasyon / dersler başarı',
  marketingPlacementStudentDashboard: 'Öğrenci paneli — sponsorlu kaynaklar',
  marketingPlacementParentDashboard: 'Veli paneli — sponsorlu kaynaklar',
  marketingPlacementMentorDashboard: 'Mentor paneli',
  marketingAnyGrade: 'Tüm sınıflar',
  marketingAnyExam: 'Tüm sınavlar',
  marketingGradeN: '{{n}}. sınıf',
  marketingSectionCampaignContent: 'Kampanya içeriği',
  marketingSectionDeliverySettings: 'Yayın ayarları',
  marketingContentLanguageNote:
    'Başlık, açıklama ve düğme metni aşağıdaki kampanya yayın dilinde saklanır. Yönetim arayüzü dilini değiştirdiğinizde bu metinler değişmez.',
  marketingFieldLanguageHint:
    'Kullanıcılar bu kampanyayı yalnızca uygulama dili bu ayarla eşleştiğinde görür. Tüm kart metinlerini bu dilde yazın.',
  marketingFieldDescriptionHint: 'Yukarıdaki yayın diliyle aynı dilde yazın.',
  marketingDeliveryLanguageBadge: 'Yayın dili: {{language}}',
  marketingPreviewTitle: 'Kart önizlemesi',
  marketingPreviewTitlePlaceholder: 'Kampanya başlığı önizlemesi',
  marketingSponsoredLabel: 'Sponsorlu',
  marketingSponsoredAria: 'Sponsorlu eğitim kaynağı',
  marketingDefaultCta: 'Daha fazla bilgi',
  marketingDashboardSectionTitle: 'Sponsorlu Kaynaklar',
  marketingValidationEndBeforeStart: 'Bitiş tarihi başlangıçtan önce olamaz.',
  marketingValidationActiveNoPlacement: 'Aktif kampanyalar için en az bir yerleşim gerekir.',
  marketingValidationActiveNoRole: 'Aktif kampanyalar için en az bir hedef rol gerekir.',
  marketingValidationAgeRange: 'Minimum yaş maksimum yaştan büyük olamaz.',
  marketingValidationGeneralTargeting: 'Genel kampanyalarda özel hedefleme kullanılamaz.',
  delete: 'Sil',
  saveChanges: 'Değişiklikleri kaydet',
  confirmPassword: 'Şifre tekrar',
  termsAccepted: 'Kullanım şartlarını kabul ediyorum',
  privacyPolicy: 'Gizlilik Politikası',
  termsAndConditions: 'Kullanım Şartları',
  legalBackToHome: '← Ana sayfaya dön',
  legalLastUpdated: 'Son güncelleme',
  registerLegalAgreementPrefix: 'Kayıt olarak',
  registerLegalAgreementJoiner: 've',
  registerSuccess:
    'Kayıt alındı. Doğrulama adımları için mobil uygulamayı kullanın veya giriş yapmayı deneyin.',
  registerFailed: 'Kayıt başarısız',
  validationEmailOrPhoneRequired: 'E-posta veya telefon gerekli',
  validationPasswordRequired: 'Şifre gerekli',
  validationEmailRequired: 'E-posta gerekli',
  validationEmailInvalid: 'Geçerli bir e-posta girin',
  validationPhoneRequired: 'Telefon gerekli',
  validationPasswordMinLength: 'En az 8 karakter',
  validationPasswordComplexity: 'Şifre bir büyük harf, bir rakam ve bir özel karakter içermelidir',
  validationConfirmPasswordRequired: 'Şifre tekrarı gerekli',
  validationPasswordsMismatch: 'Şifreler eşleşmiyor',
  validationTermsRequired: 'Şartları kabul etmelisiniz',
  validationEnterValidAmount: 'Geçerli bir tutar girin.',
  validationAmountGreaterThanZero: "Tutar 0'dan büyük olmalıdır.",
  studentsPageTitle: 'Öğrencilerim',
  studentsPageDescription: 'Hesabınıza bağlı öğrencileri yönetin.',
  studentsAdd: 'Öğrenci Ekle',
  studentsLoadError: 'Öğrenciler yüklenemedi',
  studentsEmptyTitle: 'Henüz öğrenci eklenmedi',
  studentsEmptyDescription: 'Çocuğunuzu ekleyin ve ders rezervasyonu yapmaya başlayın.',
  studentsModalTitle: 'Yeni Öğrenci Ekle',
  studentsCreate: 'Öğrenci Oluştur',
  studentsCreatedSuccess:
    'Öğrenci oluşturuldu. E-posta doğrulaması için öğrenciye bildirim gönderildi.',
  studentsCreateFailed: 'Öğrenci oluşturulamadı',
  studentsGradeLabel: 'Sınıf: {{grade}}',
  studentsVerificationHint:
    'Öğrenci hesabı oluşturulduktan sonra e-posta doğrulama adımı için öğrenciye bildirim gönderilir.',
  school: 'Okul',
  schoolNamePlaceholder: 'Okul adı',
  grade: 'Sınıf',
  gradeLevelPlaceholder: 'Örn. 10. Sınıf',
  listingDescriptionLabel: 'Açıklama ({{count}}/1000)',
  listingDescriptionPlaceholder:
    'Öğretim tarzınızı, deneyiminizi ve öğrencilerin neler öğreneceğini anlatın...',
  listingValidationSubjectRequired: 'Lütfen bir ders seçin',
  listingValidationGradeRequired: 'En az bir sınıf seviyesi seçin',
  listingValidationGradeDuplicate: 'Sınıf seviyeleri tekrarlanamaz',
  listingValidationFormatRequired: 'Lütfen bir ders formatı seçin',
  listingValidationDescriptionMin: 'Açıklama en az 50 karakter olmalıdır',
  listingValidationDescriptionMax: 'Açıklama en fazla 1000 karakter olabilir',
  parentWalletPageDescription: 'Ders kredileriniz ve cüzdan hareketleriniz.',
  parentWalletLoadError: 'Cüzdan yüklenemedi',
  parentWalletAvailableCredits: 'Kullanılabilir Krediler',
  parentWalletCreditsReadyToBook: 'rezervasyon için hazır kredi',
  parentWalletHeld: 'Bloke',
  parentWalletForBookings: 'rezervasyonlar için',
  parentWalletTotal: 'Toplam',
  parentWalletAvailablePlusHeld: 'kullanılabilir + bloke',
  parentWalletPurchased: 'Satın Alınan',
  parentWalletUsed: 'Kullanılan',
  parentWalletRefunded: 'İade',
  parentWalletBonus: 'Bonus',
  parentWalletAddCreditsCta: 'Ders rezervasyonu yapmak için kredi bakiyenizi yükleyin.',
  parentWalletCreditActivity: 'Kredi Hareketleri',
  parentWalletTxLoadError: 'İşlemler yüklenemedi',
  parentWalletEmptyTitle: 'Henüz cüzdan hareketi yok',
  parentWalletEmptyDescription:
    'Kredi satın alımlarınız ve ders rezervasyonlarınız burada görünecek.',
  parentWalletCurrentBalance: 'Mevcut Bakiye',
  parentWalletEnterAmount: 'Kredi tutarını girin',
  creditsLabel: 'kredi',
  parentWalletCreditsHelper:
    'Krediler hesabınıza anında eklenir. Herhangi bir mentorla ders rezervasyonu yapmak için kullanın.',
  parentWalletCreditsAdded: 'Krediler başarıyla eklendi.',
  parentWalletCreditsAddFailed: 'Kredi eklenemedi. Lütfen tekrar deneyin.',
  paginationPrevious: 'Önceki',
  paginationNext: 'Sonraki',
  txDummyTopup: 'Krediler eklendi',
  txCreditPurchase: 'Krediler satın alındı',
  txBonusCredit: 'Bonus krediler',
  txManualAdjustmentAdd: 'Manuel kredi ekleme',
  txManualAdjustmentRemove: 'Manuel kredi düşümü',
  txCreditHold: 'Krediler bloke edildi',
  txCreditRelease: 'Krediler serbest bırakıldı',
  txCreditSpent: 'Krediler harcandı',
  txCreditRefund: 'Krediler iade edildi',
  txBookingReversal: 'Rezervasyon iptali',
  txSystemCorrection: 'Sistem düzeltmesi',
  txWalletActivity: 'Cüzdan hareketi',
  creditAmountHeld: '{{count}} kredi bloke',
  creditAmountReturned: '+{{count}} kredi iade',
  creditAmountPositive: '+{{count}} kredi',
  creditAmountNegative: '-{{count}} kredi',
  photoPrevious: 'Önceki fotoğraf',
  photoNext: 'Sonraki fotoğraf',
  refreshListings: 'İlanları yenile',
  comingSoonTitle: 'Yakında',
  comingSoonDescription:
    "Bu bölüm mobil uygulama ile aynı API'lere bağlanacak şekilde genişletilebilir.",
  urlPlaceholder: 'https://',
  toggleMenu: 'Menüyü aç/kapat',
  closeAria: 'Kapat',
  loadingAria: 'Yükleniyor',
  switchToEnglish: 'İngilizceye geç',
  switchToTurkish: 'Türkçeye geç',
  filterChemistry: 'Kimya',
  filterBiology: 'Biyoloji',
  filterEnglish: 'İngilizce',
  stylePatient: 'Sabırlı',
  styleMotivating: 'Motive edici',
  styleDisciplined: 'Disiplinli',
  styleFriendly: 'Samimi',
  styleExamOriented: 'Sınav odaklı',
  styleSupportive: 'Destekleyici',
  styleStructured: 'Yapılandırılmış',
  styleFun: 'Eğlenceli',
  styleCalm: 'Sakin',
  styleEnergetic: 'Enerjik',
  styleGoalOriented: 'Hedef odaklı',
  readMore: 'Devamını oku',
  showLess: 'Daha az göster',
  bookingCreditsUsed: 'Kullanılan kredi',
  bookingRemainingBalance: 'Kalan bakiye',
  dashboardTotal: 'Toplam',
  dashboardAvailableShort: 'Müsait',
  dashboardBookedPercent: '%{{percent}} dolu',
  dashboardStatTodayLessons: 'Bugünkü Dersler',
  dashboardStatPendingRequests: 'Bekleyen İstekler',
  dashboardStatActiveListings: 'Aktif İlanlar',
  dashboardStatUnreadMessages: 'Okunmamış Mesajlar',
  dashboardStatAvailablePayout: 'Ödeme İçin Hazır',
  dashboardTodayPreview: 'Bugün',
  dashboardThisWeekPreview: 'Bu Hafta',
  dashboardNoLessonsToday: 'Bugün ders yok',
  dashboardTodayLessonCount: 'Bugün {{count}} ders',
  dashboardTodayLessonOne: 'Bugün 1 ders',
  dashboardWeekUpcomingCount: '{{count}} yaklaşan ders',
  dashboardWeekUpcomingOne: '1 yaklaşan ders',
  dashboardNoUpcomingThisWeek: 'Bu hafta yaklaşan ders yok',
  dashboardQuickSetAvailability: 'Müsaitlik Ayarla',
  dashboardQuickCreateListing: 'İlan Oluştur',
  dashboardQuickUploadMaterial: 'Materyal Yükle',
  dashboardQuickContactRequests: 'İletişim İsteklerini Gör',
  dashboardQuickEarnings: 'Kazançları Gör',
  dashboardPendingWorkTitle: 'Yapılacaklar',
  dashboardCaughtUp: 'Her şey tamam.',
  dashboardPendingContactRequests: '{{count}} bekleyen iletişim isteği',
  dashboardPendingContactRequestOne: '1 bekleyen iletişim isteği',
  dashboardPendingProfileRevision: 'Profil düzenlemesi inceleme bekliyor',
  dashboardPendingSubmissions: '{{count}} ödev inceleme bekliyor',
  dashboardPendingSubmissionOne: '1 ödev inceleme bekliyor',
  dashboardEarningsAvailable: 'Ödeme için hazır',
  dashboardEarningsPending: 'Bekleyen',
  dashboardViewLessons: 'Dersleri Gör',
  dashboardSetAvailability: 'Müsaitlik Ayarla',
  lessonsPageDescriptionMentor: 'Yaklaşan ve geçmiş derslerinizi buradan yönetin.',
  parentStatUpcomingLessons: 'Yaklaşan Dersler',
  parentStatCreditBalance: 'Kredi Bakiyesi',
  parentStatUnreadMessages: 'Okunmamış Mesajlar',
  parentStatLinkedStudents: 'Bağlı Öğrenciler',
  parentQuickFindMentor: 'Mentor Bul',
  parentQuickViewLessons: 'Dersleri Gör',
  parentQuickMaterials: 'Materyalleri Gör',
  parentQuickAddCredits: 'Kredi Ekle',
  parentQuickMyStudents: 'Öğrencilerim',
  studentsStatTotal: 'Toplam Öğrenci',
  studentsCardViewLessons: 'Dersler',
  studentsCardViewMaterials: 'Materyaller',
  studentsCardFavourites: 'Favoriler',
  studentsNoGrade: 'Sınıf belirtilmedi',
  materialStatAssignmentsParent: 'Ödevler',
  materialStatResourcesParent: 'Ders Kaynakları',
  materialStatSubmitted: 'Teslim Edildi',
  materialStatNotSubmitted: 'Teslim Edilmedi',
  profileSectionLinkedStudents: 'Bağlı Öğrenciler',
  profileSectionWallet: 'Cüzdan',
  parentWalletPreviewHint: 'Bakiyeyi görüntüle ve kredi ekle',
  profileMenuMyStudents: 'Öğrencilerim',
  profileMenuWallet: 'Cüzdan',
  lessonsStatToday: 'Bugünkü Dersler',
  lessonsStatReportsPending: 'Bekleyen Raporlar',
  noUpcomingLessonsMentorDescription:
    'Öğrenciler ders planladığında yeni rezervasyonlar burada görünecek.',
  noPastLessonsMentorDescription:
    'Tamamlanan dersler ve raporlar oturumlardan sonra burada görünecek.',
  lessonsViewUpcoming: 'Yaklaşan Dersleri Gör',
  lessonsViewContactRequests: 'İletişim İsteklerini Gör',
  lessonsSetAvailability: 'Müsaitlik Ayarla',
  listingsVerificationRequiredTitle: 'Doğrulama gerekli',
  listingsVerificationRequiredBody:
    'İlan yönetmeden önce kimlik ve öğrenci durumu doğrulamasını tamamlayın. Doğrulamayı bitirmek için Mentora mobil uygulamasını kullanın.',
  listingSetInactive: 'İlanı pasif yap',
  listingSetActive: 'İlanı aktif yap',
  requestFailed: 'İstek başarısız',
  reportFailed: 'Bildirim gönderilemedi',
  recordingConsentSaveFailed: 'Kayıt onayı kaydedilemedi.',
  reviewCount: '{{count}} değerlendirme',
  emailPlaceholder: 'ornek@eposta.com',
  passwordPlaceholder: '••••••••',
  otpPlaceholder: '000000',
  mentorWalletIbanPlaceholder: 'TR…',
  messagesUnreadBadge: '{{count}} okunmamış mesaj',
  languageSwitcherAria: 'Dil seçin',
  themeLight: 'Açık tema',
  themeDark: 'Koyu tema',
  themeSwitchToLight: 'Açık temaya geç',
  themeSwitchToDark: 'Koyu temaya geç',
  verificationIdentityVerified: 'Kimlik doğrulandı',
  verificationEducationVerified: 'Eğitim doğrulandı',
  verificationBackgroundChecked: 'Geçmiş kontrolü yapıldı',
  verificationReferencesChecked: 'Referanslar kontrol edildi',
  successCategorySchoolAdmission: 'Okul Kabulü',
  successCategoryExamSuccess: 'Sınav Başarısı',
  successCategoryGradeImprovement: 'Not Yükseltme',
  successCategoryGeneralProgress: 'Genel İlerleme',
  successCategoryOther: 'Diğer',
  mentorProfileNewNoReviews: 'Yeni mentor · Henüz değerlendirme yok',
  aboutMentorName: '{{name}} Hakkında',
  requestLesson: 'Ders Talep Et',
  profileNavOverview: 'Genel Bakış',
  profileNavSubjects: 'Dersler',
  profileNavTeachingStyle: 'Öğretim Tarzı',
  profileNavServices: 'Hizmetler',
  profileNavAvailability: 'Müsaitlik',
  profileNavVideo: 'Video',
  profileNavEducation: 'Eğitim',
  profileNavReviews: 'Değerlendirmeler',
  profileNavSuccessStories: 'Başarı Hikayeleri',
  profileSectionNavAriaLabel: 'Profil bölümleri',
  profileSubjectsHeading: 'Dersler ve Desteklenen Seviyeler',
  profileLevelsLabel: 'Desteklenen seviyeler',
  profileExamTypesLabel: 'Sınav hazırlığı',
  profileAvailabilityFormatsLabel: 'Mevcut ders formatları',
  profileAvailabilityEarliestLabel: 'En erken müsaitlik',
  profileAvailabilityNoSlots:
    'Henüz gösterilecek müsaitlik yok. Zamanlamayı öğrenmek için mentora talep gönderin.',
  profileVideoLoading: 'Video yükleniyor…',
  profileVideoError: 'Bu video oynatılamadı.',
  pricingSharedAfterReview: 'Ders ücreti, mentor talebinizi inceledikten sonra paylaşılacaktır.',
  profileReviewsViewAll: 'Tüm değerlendirmeleri görüntüle',
  profileReviewsShowFewer: 'Daha az göster',
  profileReviewVerifiedBadge: 'Doğrulanmış ders',
  profileSuccessStoriesViewAll: 'Tüm başarı hikayelerini görüntüle',
  profileSuccessStoriesShowFewer: 'Daha az göster',
  profileHeadlineSubjectOnly: '{{subject}} Mentoru',
  profileHeadlineSubjectAndExam: '{{subject}} Mentoru · {{exam}} Hazırlığı',
  profileVideoUnavailable: 'Tanıtım videosu bulunmuyor.',
  profileHighlightsHeading: 'Öne Çıkanlar',
  profileHighlightOnlineLessons: 'Online dersler',
  profileHighlightHybridLessons: 'Hibrit dersler',
  profileHighlightInPersonLessons: 'Yüz yüze dersler',
  profileHighlightExamPrep: 'Sınav hazırlığı',
  profileEducationSectionVerified: 'Eğitim doğrulandı',
  profileStorySharedBy: '{{name}} tarafından paylaşıldı',
};
